var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500InternalServerError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 685.5 408.4",
    style: {
      enableBackground: "new 0 0 685.5 408.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#EBEBEB;}\n\t.st3{fill:#FAFAFA;}\n\t.st4{fill:#263238;}\n\t.st5{fill:#455A64;}\n\t.st6{fill:#0061F2;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{opacity:0.4;}\n\t.st9{fill:#FFBE9D;}\n\t.st10{fill:#EB996E;}\n\t.st11{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-complete--inject-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.7,229.4c-15.5-13.3-17.1-35.2-14.5-54.6c0.4-3.2,0.4-6.7,2.2-9.4s5.6-4.3,8.4-2.6 c2.3,1.4,3.1,4.3,4.2,6.7c1.5,3.3,3.9,6,6.9,8c2,1.3,4.4,2.2,6.6,1.3c3-1.3,3.7-5.1,4-8.3l1.7-18c0.3-3.2,0.6-6.5,1.9-9.5 s3.8-5.6,7-6.1s6.8,1.6,7.1,4.8c0,1.3-0.1,2.7-0.3,4c0,1.3,0.4,2.9,1.7,3.4s2.6-0.3,3.7-1.1c3.6-2.9,6.3-6.9,8.8-10.8s5-8,8.4-11.3 s7.8-5.6,12.5-5.4s9.3,3.5,10,8.2s-2.4,9-5.6,12.4c-4.8,5-10.3,9.3-16.4,12.8c-1.2,0.5-2.1,1.4-2.8,2.4c-0.9,2.1,0.9,4.4,3,5.3 c2.3,1,4.9,1.1,7.4,1.6s5.1,1.9,5.8,4.4c1,3.4-2.1,6.6-5,8.6c-5.9,4-12.4,6.9-19.3,8.7c-2.5,0.6-5,1.1-7.1,2.6s-3.5,4.2-2.6,6.6 c0.9,2.4,3.8,3.4,6.3,3.2s4.9-1.3,7.3-2c4.6-1.2,10.3-0.4,12.7,3.8c1.6,2.7,1.4,6.2,0.2,9.1c-1.4,2.8-3.3,5.4-5.7,7.5 c-7.9,7.8-17.7,13.3-28.5,16C606.1,234.1,596.5,234.1,586.7,229.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M592.9,217.7c4.3-10.2,9.1-20.2,14.5-29.9c1.4-2.6,2.8-5.1,4.2-7.6s2.8-5,4.3-7.3c2.9-4.5,6-8.8,9.4-13 c3.2-4,6.3-7.7,9.3-11.1s5.8-6.5,8.6-9.3c4.3-4.3,8.9-8.3,13.8-11.9c1.7-1.3,3.1-2.2,4-2.9l1.1-0.7l0.4-0.2 c-0.1,0.1-0.2,0.2-0.3,0.3l-1,0.8c-0.9,0.7-2.3,1.6-4,2.9c-4.8,3.7-9.4,7.7-13.6,12.1c-2.7,2.7-5.5,5.9-8.5,9.3s-6.1,7.1-9.3,11.1 c-3.3,4.2-6.5,8.5-9.3,13c-1.5,2.3-2.8,4.8-4.2,7.3l-4.2,7.6c-5.4,9.7-10.3,19.6-14.6,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.1,172.8c-0.1-0.5-0.2-0.9-0.2-1.4c-0.1-0.9-0.2-2.2-0.2-3.8c-0.1-3.2-0.2-7.8-0.2-12.7s-0.1-9.4-0.3-12.7 c-0.1-1.6-0.2-2.9-0.2-3.8c-0.1-0.5-0.1-0.9,0-1.4c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.9,0.3,2.2,0.4,3.8c0.3,3.2,0.5,7.8,0.5,12.7 s0,9.3,0,12.7c0,1.5,0,2.8,0,3.8C616.2,171.9,616.2,172.3,616.1,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.2,169.2c-0.6,0.1-1.1,0.1-1.7,0c-1.1,0-2.6,0-4.5,0c-3.8,0-9.1,0.3-15,0.8s-11.1,1.2-14.9,1.8 c-1.9,0.3-3.4,0.6-4.5,0.8c-0.5,0.1-1.1,0.2-1.7,0.2c0.5-0.2,1.1-0.4,1.6-0.5c1-0.2,2.6-0.6,4.5-0.9c3.8-0.7,9-1.5,14.9-2 c5-0.4,10-0.6,15-0.6c1.9,0,3.5,0.1,4.5,0.2C657.1,169,657.7,169.1,658.2,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.5,217c-0.1-0.2-0.2-0.3-0.2-0.5c-0.2-0.4-0.3-0.9-0.6-1.6c-0.5-1.4-1.1-3.4-1.9-5.8 c-1.5-4.9-3.4-11.8-5.4-19.5s-3.8-14.5-5.2-19.5c-0.7-2.4-1.3-4.4-1.7-5.9l-0.5-1.6c-0.1-0.2-0.1-0.4-0.1-0.6 c0.1,0.2,0.2,0.4,0.2,0.5l0.5,1.6c0.5,1.4,1.1,3.4,1.9,5.8c1.5,4.9,3.4,11.8,5.4,19.5c2,7.6,3.8,14.5,5.2,19.5l1.7,5.9l0.5,1.6 C593.4,216.6,593.5,216.8,593.5,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650.2,204.8c-0.2,0.1-0.4,0.1-0.6,0.2l-1.7,0.4l-6.1,1.3c-5.1,1.1-12.2,2.7-20,4.5s-14.9,3.4-20.1,4.4 c-2.6,0.5-4.7,0.9-6.1,1.1l-1.7,0.3c-0.2,0-0.4,0.1-0.6,0c0.2-0.1,0.4-0.1,0.6-0.2l1.7-0.4l6.1-1.3c5.1-1.1,12.2-2.8,20-4.5 s14.9-3.4,20.1-4.4c2.6-0.5,4.7-0.9,6.1-1.1l1.7-0.3C649.8,204.8,650,204.7,650.2,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624,88.8c-4.9,1.1-9.8-2-10.8-6.9c-0.3-1.5-0.3-3.1,0.2-4.7l15.5-50c0.9-3.1,3.5-5.5,6.7-6.2l0,0 c3.2-0.7,6.5,0.3,8.7,2.7l35.5,38.4c3.4,3.7,3.2,9.4-0.5,12.8c-1.2,1.1-2.6,1.8-4.1,2.2L624,88.8L624,88.8z M636.2,23.7L636.2,23.7 c-2.2,0.5-4,2.1-4.7,4.3L616,78c-1,3.4,0.9,6.9,4.2,8c1.1,0.3,2.2,0.4,3.3,0.1l0,0l51.1-11.5c3.4-0.8,5.6-4.2,4.8-7.6 c-0.2-1.1-0.8-2.1-1.5-2.9l-35.5-38.5C640.7,23.9,638.4,23.2,636.2,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.7,69.6c-0.4-1.8,0.7-3.6,2.5-4c0,0,0.1,0,0.1,0c1.8-0.5,3.6,0.6,4.1,2.3c0,0,0,0.1,0,0.1 c0.4,1.8-0.7,3.6-2.5,4c0,0-0.1,0-0.1,0c-1.8,0.5-3.7-0.6-4.1-2.4C642.7,69.7,642.7,69.6,642.7,69.6z M636.9,42.9l6.2-1.4l3.5,20 l-4.2,1L636.9,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.1,228.2c0,0-6.4,3.6,3.2,17s16,19.8,16,19.8s1.8,3.2-0.9,4.1s-9.2,0.9-9.9,4.6s2.4,6.8,8.2,9 s18.3,7.4,19.4,7.9s2.4,1.9,0.6,2.8s-15.7,4.6-13.6,11.1s19.2,9.9,21.1,10.3s2.4,1.1,2.4,2.1s-4.8,1.8-8.7,3s-8.2,3.3-6.7,6.9 s12.4,10.1,36,8.8l10.9-1.3l4.5-10.1c8.3-22.2,5.3-34.4,2.3-37s-6.3,1-8.6,4.3s-4.5,7.7-5.4,7.4s-1.4-1-1.3-2.9s2-19.2-3.5-23.2 S65,281,63.5,282.4c-1.4,1.4-2.4-0.2-2.5-1.4s-1.4-14.7-1.7-20.9S57,250,53.1,249.6s-5.6,5.7-7.3,8.1s-4.2-0.3-4.2-0.3 s-4.3-7.8-14.2-21.1s-15.4-8-15.4-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,336.7c-7.2-9.8-19.9-27.3-30.8-42.3s-20.8-28.6-28-38.4l-8.5-11.6l-2.3-3.1l-0.6-0.8 c-0.1-0.2-0.2-0.3-0.2-0.3c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.2,0.4,0.5,0.6,0.8c0.6,0.7,1.3,1.8,2.4,3.1c2.1,2.7,5,6.6,8.6,11.5 c7.3,9.8,17.2,23.3,28.1,38.3s23.5,32.6,30.7,42.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4,274.2c0.3,0,0.5,0,0.8,0.1c0.5,0.1,1.2,0.2,2.1,0.4c1.8,0.4,4.2,0.9,7,1.6l6.9,1.7l2.1,0.5 c0.3,0,0.5,0.1,0.8,0.2c-0.3,0-0.5,0-0.8-0.1c-0.5-0.1-1.2-0.2-2.1-0.4c-1.8-0.4-4.2-1-7-1.6l-6.9-1.7l-2.1-0.5 C29.9,274.4,29.6,274.3,29.4,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,277.9c-0.1,0,0.8-5.1,2.1-11.5s2.3-11.4,2.4-11.4s-0.8,5.1-2.1,11.5S49.8,278,49.7,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4,301.7c0.1-0.3,0.2-0.5,0.3-0.7l1-2c0.8-1.6,2-4,3.2-6.5s2.2-4.9,2.9-6.7c0.3-0.8,0.6-1.5,0.8-2 c0.1-0.3,0.2-0.5,0.3-0.7c0,0.3-0.1,0.5-0.2,0.8c-0.2,0.5-0.4,1.2-0.8,2.1c-0.7,1.7-1.6,4.1-2.8,6.7s-2.4,4.9-3.3,6.5 c-0.5,0.8-0.8,1.5-1.1,1.9C65.7,301.3,65.6,301.5,65.4,301.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,302.4c0.2-0.1,0.5-0.1,0.7-0.1l2-0.1c1.7-0.1,4.1-0.2,6.7-0.4s5-0.2,6.7-0.3h2c0.2,0,0.5,0,0.8,0 c-0.2,0.1-0.5,0.1-0.7,0.1l-2,0.1c-1.7,0.1-4.1,0.2-6.7,0.4s-5,0.2-6.7,0.3h-2C46.8,302.4,46.6,302.4,46.3,302.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.5,325.2c0.3-0.1,0.6-0.1,0.9-0.1l2.6-0.2c2.2-0.2,5.2-0.4,8.6-0.5s6.4-0.4,8.6-0.5l2.6-0.1 c0.3,0,0.7,0,1,0c-0.3,0.1-0.7,0.1-1,0.1l-2.6,0.2c-2.2,0.1-5.2,0.4-8.6,0.5s-6.4,0.4-8.6,0.5l-2.6,0.1 C58.1,325.2,57.8,325.2,57.5,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,323.6c0.1-0.3,0.2-0.6,0.4-1c0.3-0.6,0.7-1.5,1.2-2.5c1-2.1,2.4-5.1,3.8-8.4s2.7-6.3,3.5-8.5 c0.4-1,0.8-1.9,1-2.6c0.1-0.3,0.2-0.6,0.4-0.9c-0.1,0.3-0.2,0.7-0.3,1c-0.2,0.6-0.5,1.5-0.9,2.6c-0.8,2.2-2,5.3-3.4,8.6 s-2.8,6.3-3.9,8.4c-0.5,1-1,1.9-1.3,2.5C81.6,323.1,81.4,323.4,81.2,323.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 24,
    className: "st0",
    width: 104.1,
    height: 319
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.6,
    y: 24,
    className: "st3",
    width: 82.3,
    height: 319
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 75,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 78.1,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,82.1c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,80.6,104.7,81.3,104.7,82.1L104.7,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,88.9c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,87.3,104.6,88,104.7,88.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 80.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 114.8,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 118,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,122c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,120.4,104.7,121.1,104.7,122z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 103.1,
    cy: 128.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 120.4,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 154.7,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 157.8,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,161.8c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,160.2,104.6,160.9,104.7,161.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 103.1,
    cy: 168.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 160.2,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 194.5,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 197.6,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,201.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,200.1,104.7,200.8,104.7,201.6L104.7,201.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,208.4c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,206.8,104.7,207.5,104.7,208.4C104.7,208.4,104.7,208.4,104.7,208.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 200.1,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 234.4,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 237.5,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,241.5c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,239.9,104.7,240.6,104.7,241.5L104.7,241.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 103.1,
    cy: 248.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 239.9,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 274.2,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 277.3,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,281.3c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,279.8,104.7,280.5,104.7,281.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,288c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,286.5,104.7,287.2,104.7,288L104.7,288z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 279.8,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 314,
    className: "st1",
    width: 88.3,
    height: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 317.2,
    className: "st0",
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.7,321.2c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0 C103.9,319.6,104.6,320.3,104.7,321.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 103.1,
    cy: 327.9,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.1,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 319.6,
    className: "st0",
    width: 4.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146,75c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.5-0.1-1.2-0.1-2.2s-0.1-2.1-0.1-3.5c0-1.5-0.3-3-0.6-4.5 c-0.5-1.8-1.3-3.5-2.4-5c-1.2-1.7-2.9-3.1-4.8-3.9c-2.2-0.8-4.5-1.3-6.9-1.4l-7.6-0.7c-10.4-0.9-19.9-1.5-26.7-1.6 c-3.4-0.1-6.2-0.1-8.1,0h-2.2c-0.3,0-0.5,0-0.8,0c0.3-0.1,0.5-0.1,0.8-0.1l2.2-0.1c1.9-0.1,4.7-0.2,8.1-0.2 c6.9,0,16.3,0.5,26.8,1.4l7.6,0.7c2.4,0.1,4.8,0.6,7,1.5c2,0.9,3.8,2.3,5,4.1c1.1,1.6,1.9,3.3,2.4,5.2c0.3,1.5,0.5,3.1,0.5,4.6 c0,1.4,0,2.5,0,3.5s0,1.6,0,2.2C146.1,74.5,146.1,74.8,146,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,75c0-0.2-0.1-0.5-0.1-0.7c0-0.5,0-1.2,0-2.1s0-2-0.1-3.3c-0.1-1.4-0.4-2.8-1.1-4.1c-1-1.4-2.4-2.5-4-3 c-1.8-0.7-3.8-0.9-5.8-0.6c-1,0.2-2.1,0.5-3,1c-1,0.5-1.8,1.3-2.3,2.2c-0.5,1-0.5,2.1,0,3.1c0.6,1,1.5,1.7,2.6,2 c1.1,0.2,2.3-0.1,3.1-0.9c1.7-1.6,1.9-4.1,0.5-5.9c-0.6-0.8-1.4-1.5-2.3-2c-0.9-0.4-1.9-0.7-2.9-0.8c-1-0.1-2-0.3-2.9-0.4 c-1.9-0.2-3.6-0.3-5.2-0.4c-3.2-0.1-5.8-0.1-7.6-0.1h-2.1c-0.2,0-0.5,0-0.7,0c0.2-0.1,0.5-0.1,0.7-0.1l2.1-0.1 c1.8-0.1,4.4-0.2,7.7-0.1c1.6,0,3.4,0.1,5.3,0.3c1,0.1,1.9,0.2,2.9,0.4c0.5,0.1,1,0.1,1.5,0.2c0.5,0.1,1.1,0.3,1.6,0.5 c1,0.5,1.9,1.3,2.6,2.2c0.7,1,1.1,2.2,1,3.4c-0.1,1.3-0.6,2.5-1.6,3.3c-1,0.9-2.3,1.3-3.6,1c-1.3-0.3-2.4-1.1-3-2.3 c-0.6-1.1-0.6-2.5,0-3.7c0.6-1,1.5-1.9,2.6-2.4c1-0.5,2.1-0.9,3.2-1.1c2.1-0.3,4.2-0.1,6.1,0.7c1.7,0.6,3.2,1.8,4.2,3.3 c0.6,1.3,1,2.8,1,4.3c0.1,1.3,0,2.4,0,3.3s-0.1,1.5-0.1,2.1C119.3,74.6,119.3,74.8,119.2,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.2,75c-0.1-0.3-0.1-0.5-0.2-0.8c-0.1-0.6-0.3-1.3-0.5-2.4c-0.6-2.9-1.5-5.7-2.6-8.4 c-1.6-4.1-4.3-7.6-7.7-10.3c-2.1-1.5-4.5-2.4-7-2.7c-2.7-0.3-5.5-0.4-8.3-0.4c-11.4-0.2-21.8-0.2-29.2-0.5C94,49.4,91,49.2,88.9,49 l-2.4-0.2c-0.3,0-0.6,0-0.8-0.1c0.3,0,0.6,0,0.8,0l2.4,0.1c2.1,0.1,5.1,0.2,8.9,0.3c7.5,0.2,17.8,0.1,29.2,0.3 c2.8,0,5.6,0.1,8.4,0.5c2.6,0.3,5.2,1.2,7.3,2.8c1.9,1.4,3.5,3.2,4.9,5.2c1.1,1.7,2.1,3.5,2.9,5.4c1.1,2.8,1.9,5.6,2.4,8.5 c0.2,1,0.3,1.8,0.4,2.4C153.2,74.5,153.3,74.7,153.2,75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.6,
    y: 27.9,
    className: "st1",
    width: 85.9,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 34.1,
    className: "st0",
    width: 46.8,
    height: 6.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Servers--inject-114"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.1,
    y: 222.1,
    className: "st4",
    width: 138.6,
    height: 98.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.9,
    y: 212,
    className: "st5",
    width: 151.5,
    height: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.8,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C267.1,220.4,267.8,221.2,267.8,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.4,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.6,220.4,275.4,221.2,275.4,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.9,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C282.2,220.4,282.9,221.2,282.9,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.5,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.7,220.4,290.5,221.2,290.5,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C348.2,220.4,349,221.2,349,222.1C349,222.1,349,222.1,349,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.7,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C355.9,220.4,356.7,221.2,356.7,222.1C356.7,222.1,356.7,222.1,356.7,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C297.3,220.4,298,221.2,298,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.1,222.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C334.3,220.4,335.1,221.2,335.1,222.1C335.1,222.1,335.1,222.1,335.1,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.6,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.8,220.4,305.6,221.2,305.6,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.1,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C312.4,220.4,313.1,221.2,313.1,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.4,222.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.7,220.4,328.4,221.2,328.4,222.1C328.4,222.1,328.4,222.1,328.4,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.9,222.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C362.2,220.4,362.9,221.2,362.9,222.1C362.9,222.1,362.9,222.1,362.9,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.7,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C319.9,220.4,320.7,221.2,320.7,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M342.2,222.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341.5,220.4,342.2,221.2,342.2,222.1C342.2,222.1,342.2,222.1,342.2,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M359.5,230.4c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C360.3,232.1,359.5,231.3,359.5,230.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 353.7,
    cy: 230.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.4,230.4c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C345.2,232.1,344.4,231.3,344.4,230.4C344.4,230.4,344.4,230.4,344.4,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M336.9,230.4c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C337.6,232.1,336.9,231.3,336.9,230.4C336.9,230.4,336.9,230.4,336.9,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278.4,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C279.1,232.1,278.4,231.3,278.4,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.7,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C271.4,232.1,270.7,231.3,270.7,230.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 331,
    cy: 230.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 294,
    cy: 230.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.8,230.4c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C322.5,232.1,321.8,231.3,321.8,230.4C321.8,230.4,321.8,230.4,321.8,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.2,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C315,232.1,314.2,231.3,314.2,230.4C314.2,230.4,314.2,230.4,314.2,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.9,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C299.7,232.1,298.9,231.3,298.9,230.4C298.9,230.4,298.9,230.4,298.9,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.4,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C265.2,232.1,264.4,231.3,264.4,230.4C264.4,230.4,264.4,230.4,264.4,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.7,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C307.4,232.1,306.7,231.3,306.7,230.4C306.7,230.4,306.7,230.4,306.7,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.1,230.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C285.8,232.1,285.1,231.3,285.1,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.8,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C267.1,236,267.8,236.8,267.8,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.4,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.6,236,275.4,236.8,275.4,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.9,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C282.2,236,282.9,236.8,282.9,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.5,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.7,236,290.5,236.8,290.5,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C348.2,236,349,236.8,349,237.7C349,237.7,349,237.7,349,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.7,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C355.9,236,356.7,236.8,356.7,237.7C356.7,237.7,356.7,237.7,356.7,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C297.3,236,298,236.8,298,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.1,237.7c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C334.3,236,335.1,236.8,335.1,237.7C335.1,237.7,335.1,237.7,335.1,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.6,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.8,236,305.6,236.8,305.6,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.1,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C312.4,236,313.1,236.8,313.1,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.4,237.7c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.7,236,328.4,236.8,328.4,237.7C328.4,237.7,328.4,237.7,328.4,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.9,237.7c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C362.2,236,362.9,236.8,362.9,237.7C362.9,237.7,362.9,237.7,362.9,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.7,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C319.9,236,320.7,236.8,320.7,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M342.2,237.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341.5,236,342.2,236.8,342.2,237.7C342.2,237.7,342.2,237.7,342.2,237.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 219.7,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 227.6,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 235.8,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.9,
    y: 258.4,
    className: "st5",
    width: 151.5,
    height: 37.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 266.1,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 274,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.6,
    y: 282.2,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.2,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C266.5,266.9,267.2,267.6,267.2,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.8,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.1,266.9,274.8,267.6,274.8,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.4,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C281.6,266.9,282.4,267.6,282.4,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.9,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.2,266.9,289.9,267.6,289.9,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.4,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C347.7,266.9,348.4,267.6,348.4,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.1,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C355.4,266.9,356.1,267.6,356.1,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.5,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C296.7,266.9,297.5,267.6,297.5,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M334.6,268.6c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C333.8,266.9,334.5,267.6,334.6,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.3,266.9,305,267.6,305,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.6,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C311.8,266.9,312.6,267.6,312.6,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.9,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.1,266.9,327.9,267.6,327.9,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.4,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C361.6,266.9,362.4,267.6,362.4,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.1,268.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C319.4,266.9,320.1,267.6,320.1,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M341.7,268.6c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341,266.8,341.7,267.6,341.7,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M359,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C359.7,278.5,359,277.7,359,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351.4,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C352.2,278.5,351.4,277.7,351.4,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.9,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C344.6,278.5,343.9,277.7,343.9,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M336.3,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C337.1,278.5,336.3,277.7,336.3,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.8,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C278.6,278.5,277.8,277.7,277.8,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.1,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C270.9,278.5,270.1,277.7,270.1,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.8,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C329.5,278.5,328.8,277.7,328.8,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.7,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C292.5,278.5,291.7,277.7,291.7,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.2,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C322,278.5,321.2,277.7,321.2,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.7,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C314.4,278.5,313.7,277.7,313.7,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.4,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C299.1,278.5,298.4,277.7,298.4,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.9,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C264.6,278.5,263.9,277.7,263.9,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.1,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C306.9,278.5,306.1,277.7,306.1,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284.5,276.8c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C285.3,278.5,284.5,277.7,284.5,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.2,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C266.5,282.4,267.2,283.2,267.2,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.8,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.1,282.4,274.8,283.2,274.8,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.4,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C281.6,282.4,282.4,283.2,282.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.9,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.2,282.4,289.9,283.2,289.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.4,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C347.7,282.4,348.4,283.2,348.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.1,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C355.4,282.4,356.1,283.2,356.1,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.5,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C296.7,282.4,297.5,283.2,297.5,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M334.6,284.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C333.8,282.4,334.5,283.2,334.6,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.3,282.4,305,283.2,305,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.6,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C311.8,282.4,312.6,283.2,312.6,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.9,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.1,282.4,327.9,283.2,327.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.4,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C361.6,282.4,362.4,283.2,362.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.1,284.1c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C319.4,282.4,320.1,283.2,320.1,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M341.7,284.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341,282.4,341.7,283.2,341.7,284.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "394.1,249.2 371.3,249.3 371.3,211.7 394.1,211.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "394.1,295.9 371.3,296 371.3,258.4 394.1,258.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "392.7,342.9 369.9,343 369.9,305.4 392.7,305.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.6,
    y: 305.4,
    className: "st5",
    width: 151.5,
    height: 37.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 313.1,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 321,
    className: "st4",
    width: 29.8,
    height: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.9,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C267.1,314.2,267.9,315,267.9,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.4,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.7,314.2,275.4,315,275.4,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C282.2,314.2,283,315,283,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.5,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.8,314.2,290.5,315,290.5,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C348.3,314.2,349,315,349,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.7,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C356,314.2,356.7,315,356.7,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298.1,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C297.3,314.2,298.1,315,298.1,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.2,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C334.4,314.2,335.2,315,335.2,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.6,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.9,314.2,305.6,315,305.6,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.2,315.9c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C312.5,314.2,313.2,315,313.2,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.5,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.7,314.2,328.5,315,328.5,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C362.2,314.2,363,315,363,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.7,315.9c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C320,314.2,320.7,315,320.7,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M342.4,315.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341.6,314.2,342.4,315,342.4,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M359.6,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C360.3,325.9,359.6,325.1,359.6,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C352.8,325.9,352,325.1,352,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.5,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C345.2,325.9,344.5,325.1,344.5,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M336.9,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C337.7,325.9,336.9,325.1,336.9,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278.4,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C279.2,325.9,278.4,325.1,278.4,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.7,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C271.5,325.9,270.7,325.1,270.7,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.4,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C330.1,325.9,329.4,325.1,329.4,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.3,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C293.1,325.9,292.3,325.1,292.3,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.8,324.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C322.6,325.9,321.8,325.1,321.8,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.2,324.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C315,325.9,314.2,325.1,314.2,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C299.7,325.9,299,325.1,299,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C265.2,325.9,264.5,325.1,264.5,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.7,324.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C307.5,325.9,306.7,325.1,306.7,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.1,324.2c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c0,0,0,0,0,0 C285.9,325.9,285.1,325.1,285.1,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.9,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C267.1,329.8,267.9,330.5,267.9,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.4,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C274.7,329.8,275.4,330.5,275.4,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C282.2,329.8,283,330.5,283,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.5,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C289.8,329.8,290.5,330.5,290.5,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C348.3,329.8,349,330.5,349,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M356.7,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C356,329.8,356.7,330.5,356.7,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298.1,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C297.3,329.8,298.1,330.5,298.1,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.2,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C334.4,329.8,335.2,330.5,335.2,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.6,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C304.9,329.8,305.6,330.5,305.6,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.2,331.5c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C312.5,329.8,313.2,330.5,313.2,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.5,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C327.7,329.8,328.5,330.5,328.5,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C362.2,329.8,363,330.5,363,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.7,331.5c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0,0,0,0,0,0 C320,329.8,320.7,330.5,320.7,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M342.4,331.5c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0,0,0,0,0,0 C341.6,329.8,342.4,330.5,342.4,331.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.4,
    className: "st2",
    width: 112,
    height: 343
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "599.7,343 511.4,343 511.2,0 599.7,0  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 54.9,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 58.3,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,62.6c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,61.6,419.8,62.6 C419.8,62.6,419.8,62.6,419.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,69.8c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,68.9,419.8,69.8L419.8,69.8z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 60.9,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 93.3,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 96.7,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,101c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,100,419.8,101L419.8,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,108.2c0,0.9-0.7,1.7-1.6,1.7s-1.7-0.7-1.7-1.6s0.7-1.7,1.6-1.7c0,0,0,0,0,0 C419.1,106.6,419.8,107.3,419.8,108.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 99.3,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 132,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 135.4,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,139.7c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,138.8,419.8,139.7 L419.8,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,146.9c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,146,419.8,146.9 L419.8,146.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 138,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 173.8,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 177.2,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,181.6c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,180.6,419.8,181.6 L419.8,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,188.8c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S419.8,187.8,419.8,188.8 L419.8,188.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 179.8,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 216.1,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 219.5,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,223.8c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,222.8,419.8,223.8L419.8,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,231c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,230.1,419.8,231L419.8,231z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 222.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 300.2,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 303.5,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,307.8c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,306.9,419.8,307.8L419.8,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,315.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,314.1,419.8,315.1L419.8,315.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 306.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 258.2,
    className: "st4",
    width: 95,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.3,
    y: 261.5,
    className: "st5",
    width: 5.3,
    height: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,265.8c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,264.9,419.8,265.8L419.8,265.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.8,273.1c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7S419.8,272.1,419.8,273.1L419.8,273.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.1,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.7,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.8,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.3,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.9,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.4,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.5,
    y: 264.1,
    className: "st5",
    width: 5.2,
    height: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M464.3,54.9c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.5-0.1-1.3-0.1-2.4s0-2.3-0.1-3.8c0-1.6-0.3-3.3-0.6-4.9 c-0.5-1.9-1.4-3.7-2.5-5.3c-1.3-1.9-3.1-3.3-5.2-4.2c-2.4-0.9-4.9-1.4-7.4-1.5l-8.2-0.7c-11.2-1-21.4-1.6-28.7-1.7 c-3.7-0.1-6.7,0-8.7,0l-2.4-0.1c-0.3,0-0.6,0-0.8,0c0.3-0.1,0.5-0.1,0.8-0.1l2.4-0.1c2.1-0.1,5-0.2,8.7-0.2 c7.4,0,17.6,0.6,28.8,1.6l8.2,0.7c2.6,0.1,5.1,0.7,7.5,1.6c2.2,0.9,4.1,2.5,5.4,4.4c1.2,1.7,2,3.6,2.5,5.5c0.4,1.6,0.6,3.3,0.6,5 c0,1.5,0,2.7,0,3.8s0,1.8,0,2.4C464.4,54.4,464.4,54.6,464.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M435.5,54.9c0-0.3-0.1-0.5-0.1-0.8c0-0.6,0-1.3,0-2.2s0-2.2-0.1-3.5c-0.1-1.5-0.5-3-1.2-4.4 c-1-1.5-2.5-2.7-4.3-3.3c-2-0.8-4.2-1-6.3-0.6c-1.1,0.2-2.2,0.6-3.2,1.1c-1,0.5-1.9,1.4-2.5,2.4c-0.6,1-0.6,2.3,0,3.3 c0.6,1.1,1.6,1.9,2.9,2.1c1.2,0.3,2.5-0.1,3.3-1c0.9-0.8,1.4-2,1.5-3.2c0.1-1.2-0.3-2.3-1-3.2c-0.6-0.9-1.5-1.7-2.5-2.2 c-1-0.5-2.1-0.7-3.1-0.8c-1.1-0.2-2.1-0.3-3.1-0.4c-2-0.2-3.9-0.4-5.6-0.4c-3.5-0.1-6.3-0.1-8.2-0.1h-2.2c-0.3,0-0.5,0-0.8,0 c0.3-0.1,0.5-0.1,0.8-0.1l2.2-0.1c1.9-0.1,4.8-0.2,8.2-0.1c1.7,0.1,3.6,0.2,5.7,0.4c1,0.1,2.1,0.2,3.1,0.4c0.5,0.1,1.1,0.2,1.6,0.3 c0.6,0.1,1.1,0.3,1.7,0.6c1.1,0.6,2,1.4,2.7,2.4c0.8,1,1.2,2.3,1.1,3.6c-0.1,1.4-0.7,2.6-1.7,3.6c-1,1-2.5,1.4-3.9,1.1 c-1.4-0.3-2.6-1.2-3.2-2.4c-0.7-1.2-0.7-2.7,0-3.9c0.6-1.1,1.6-2,2.8-2.6c1.1-0.6,2.2-1,3.4-1.2c2.2-0.4,4.5-0.1,6.5,0.7 c1.8,0.6,3.4,1.9,4.5,3.6c0.7,1.4,1.1,3,1.1,4.6c0.1,1.4,0,2.6,0,3.5s-0.1,1.7-0.1,2.2C435.6,54.4,435.6,54.6,435.5,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M472.1,54.9c-0.1-0.3-0.2-0.6-0.2-0.9c-0.1-0.6-0.3-1.4-0.5-2.5c-0.6-3.1-1.6-6.1-2.8-9.1 c-1.7-4.4-4.6-8.2-8.3-11.1c-2.2-1.6-4.8-2.6-7.6-2.9c-3-0.3-5.9-0.5-8.9-0.5c-12.3-0.2-23.4-0.2-31.5-0.5c-4-0.1-7.3-0.3-9.5-0.5 l-2.6-0.2c-0.3,0-0.6-0.1-0.9-0.1c0.3,0,0.6,0,0.9,0l2.6,0.1c2.2,0.1,5.5,0.2,9.5,0.3c8,0.2,19.2,0.1,31.5,0.3c3,0,6,0.2,9,0.5 c2.8,0.3,5.5,1.3,7.8,3c2,1.6,3.8,3.4,5.2,5.5c1.2,1.8,2.3,3.8,3.1,5.8c1.2,3,2.1,6,2.6,9.2c0.2,1.1,0.3,2,0.4,2.6 C472.1,54.3,472.1,54.6,472.1,54.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.9,
    y: 4.3,
    className: "st4",
    width: 92.4,
    height: 13.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.2,
    y: 11,
    className: "st5",
    width: 50.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M537,282.4c0,0.1-1,0.2-2.8,0.7c-2.5,0.7-4.9,1.9-7,3.4c-1.5,1-2.8,2.2-3.9,3.6c-0.6,0.8-1.2,1.6-1.6,2.5 c-0.4,1-0.8,2-1,3c-1,4.2-0.7,9.1-0.5,14.1s-0.1,10.1-2.1,14.1c-0.9,1.9-2.2,3.6-3.8,5c-2.6,2.2-5.7,3.7-9,4.2 c-1.1,0.2-2.3,0.2-3.4,0.1c-0.7,0-1.4-0.2-2.1-0.3c-0.2,0-0.5-0.1-0.7-0.2c0-0.1,1,0.2,2.8,0.3c1.1,0,2.2-0.1,3.3-0.2 c1.5-0.3,2.9-0.7,4.2-1.4c1.6-0.7,3.1-1.7,4.5-2.9c1.5-1.4,2.7-3,3.6-4.9c1.9-3.9,2.2-8.8,2-13.9s-0.5-10,0.6-14.3 c0.3-1.1,0.6-2.1,1.1-3.1c0.5-0.9,1-1.8,1.7-2.6c1.2-1.4,2.5-2.6,4.1-3.7c2.2-1.5,4.6-2.6,7.2-3.3c0.7-0.2,1.4-0.3,2.1-0.4 C536.4,282.3,536.7,282.3,537,282.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.4,
    y: 328.5,
    className: "st4",
    width: 7.6,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 259,
    className: "st5",
    width: 42.5,
    height: 46.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 558.2,
    cy: 282.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 558.2,
    cy: 282.5,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 542.7,
    cy: 266.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M574.2,266.3c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0 C573.7,265,574.2,265.6,574.2,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M574.5,300.7c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0 C574,299.4,574.5,300,574.5,300.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M544,301.2c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0 C543.4,299.9,544,300.5,544,301.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.5,
    y: 259,
    className: "st4",
    width: 3.4,
    height: 46.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "speech-bubble--inject-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.9,139.2l-18.5-4.6h0.1c-4.8,3-10.3,4.7-16,4.8c-3.4,0-6.7-0.5-9.9-1.4C10,134.2,1.7,124.2,0.2,112.1 c-1.1-9,1.8-18.1,8-24.8c1.6-1.8,3.4-3.3,5.4-4.7c1-0.6,2-1.3,3-1.8l1.6-0.8l0.8-0.4l0.8-0.3c4.2-1.6,8.8-2.3,13.3-2 c12.4,0.8,23.1,9,27.1,20.7c1.1,3.2,1.7,6.6,1.7,10c0,5.7-1.5,11.2-4.4,16.1v-0.2C62.7,133.4,65.3,138.1,65.9,139.2 c-0.6-1.1-3.3-5.7-8.6-14.9v-0.1v-0.1c2.9-4.8,4.3-10.3,4.3-15.9c-0.1-3.4-0.6-6.7-1.7-9.9c-1.2-3.5-3-6.7-5.4-9.6 c-8.4-10-22.2-13.5-34.4-8.8l-0.8,0.3l-0.8,0.4l-1.5,0.7c-1,0.5-2,1.2-3,1.8c-1.9,1.3-3.7,2.9-5.3,4.6 c-11.4,12.4-10.6,31.7,1.9,43.1c3.2,3,7.1,5.2,11.3,6.6c3.2,1,6.4,1.5,9.8,1.5c5.6-0.1,11-1.7,15.8-4.6h0.1h0.1L65.9,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.4,94.6l1,15.5c0.1,1.3,1.1,2.3,2.4,2.4l0,0c1.3,0.1,2.5-0.9,2.6-2.2l1.7-15.6c0.1-1.1-0.7-2.1-1.8-2.2 c-0.1,0-0.1,0-0.2,0l-3.8,0.1C29.3,92.6,28.4,93.5,28.4,94.6C28.4,94.6,28.4,94.6,28.4,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.9,121.2c-0.7,2-2.8,3.1-4.8,2.4s-3.1-2.8-2.4-4.8s2.8-3.1,4.8-2.4c0,0,0,0,0,0 C35.4,117,36.5,119.2,35.9,121.2C35.9,121.2,35.9,121.2,35.9,121.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Device--inject-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283,93.5c-0.1,0-0.9-1.1-2.4-2.9s-3.6-4.1-5.9-6.8s-4.4-5.1-5.8-6.9c-0.7-0.9-1.2-1.7-1.6-2.2 c-0.2-0.3-0.4-0.6-0.5-0.9c0.1,0,0.9,1.1,2.4,2.9s3.6,4.1,5.9,6.8s4.4,5.1,5.8,6.9c0.7,0.9,1.2,1.7,1.6,2.2 C282.7,92.9,282.9,93.2,283,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,83c-0.1,0.1-4.3-12-9.4-27s-9-27.1-8.9-27.1s4.3,12,9.4,27S302.3,83,302.2,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.8,86.2c-0.1-0.1,1.9-6.7,4.6-14.9s4.9-14.8,5.1-14.7s-1.9,6.7-4.6,14.9S318.9,86.2,318.8,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.9,85.3c0.1,0.1-2.5,2.1-5.5,4.6s-5.4,4.7-5.5,4.6c0.4-0.6,0.9-1.1,1.4-1.6c0.9-0.9,2.2-2.1,3.8-3.4 s3-2.4,4-3.1C345.6,86,346.2,85.6,346.9,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M331.8,45.1c0.1,0,0,0.8-0.3,1.7s-0.6,1.5-0.8,1.5s0-0.8,0.3-1.7S331.6,45.1,331.8,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M262,68.6c-0.1,0.1-0.5-0.3-0.9-0.8s-0.6-1-0.4-1.1s0.5,0.3,0.9,0.8S262.1,68.6,262,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M369.1,100.6H243.3c-2.2,0-3.9,1.8-3.9,3.9v88.9c0,2.2,1.8,3.9,3.9,3.9h48.3c0,0,3.1,9.5-6.5,14.4h45.1 c0,0-10.8-3.7-8-14.4h46.8c2.2,0,3.9-1.8,3.9-3.9v-88.9C373.1,102.3,371.3,100.6,369.1,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.9,187.9c0.9,1,0.7,2.5-0.3,3.4c-0.9,0.8-2.2,0.8-3.1,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.9-1-0.7-2.5,0.3-3.4 c0.9-0.8,2.2-0.8,3.1,0C307.8,187.8,307.9,187.8,307.9,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M244.4,102.2h123.6c1.6,0,2.9,1.3,2.9,2.8v0v76l0,0H241.6l0,0v-76C241.6,103.5,242.9,102.2,244.4,102.2 L244.4,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.6,102.2h123.9c1.4,0,2.5,1.1,2.5,2.4c0,0,0,0,0,0v4.1l0,0H241.6l0,0v-3.6 C241.6,103.5,242.9,102.2,244.6,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.6,105.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9c0,0,0,0,0,0 C246.2,104.7,246.6,105.1,246.6,105.6C246.6,105.6,246.6,105.6,246.6,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.3,105.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9 C248.9,104.7,249.3,105.1,249.3,105.6C249.3,105.6,249.3,105.6,249.3,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,105.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9 C251.5,104.7,251.9,105.1,251.9,105.6C251.9,105.6,251.9,105.6,251.9,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M346.7,197.3c0,0-17.9,0.1-40,0.1s-40,0-40-0.1s17.9-0.1,40-0.1S346.7,197.2,346.7,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294,137.7c0,4-2.9,7.4-9.4,7.4c-3,0.1-6-0.8-8.6-2.4l2.1-4c1.9,1.3,4.1,2,6.4,2c2.6,0,4.2-1.1,4.2-2.9 s-1.1-2.9-5.2-2.9h-5.8l1.2-12.6h13.7v4.2h-9.4l-0.4,4.3h1.8C291.4,130.7,294,133.7,294,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.1,133.6c0-7.4,4.1-11.6,9.6-11.6s9.6,4.2,9.6,11.6s-4.1,11.6-9.6,11.6S296.1,140.9,296.1,133.6z  M310.1,133.6c0-5.1-1.8-7.2-4.4-7.2s-4.4,2.1-4.4,7.2s1.8,7.2,4.4,7.2S310.1,138.6,310.1,133.6L310.1,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,133.6c0-7.4,4.1-11.6,9.6-11.6s9.6,4.2,9.6,11.6s-4.1,11.6-9.6,11.6S317.9,140.9,317.9,133.6z  M331.9,133.6c0-5.1-1.8-7.2-4.4-7.2s-4.4,2.1-4.4,7.2s1.8,7.2,4.4,7.2S331.9,138.6,331.9,133.6L331.9,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M260.8,150.6h1v6.6h-1V150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269.4,150.6v6.6h-0.8l-4-4.9v4.9h-1v-6.6h0.8l4,5v-5H269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.7,151.4h-2.3v-0.8h5.5v0.8h-2.3v5.8h-0.9V151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281.8,156.4v0.8H277v-6.6h4.7v0.8h-3.7v2h3.3v0.8h-3.3v2.1L281.8,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.8,157.3l-1.4-2h-0.4h-1.7v2h-0.9v-6.6h2.6c1.7,0,2.8,0.9,2.8,2.3c0,0.9-0.6,1.8-1.5,2.1l1.6,2.2H287.8z  M287.8,152.9c0-0.9-0.6-1.5-1.9-1.5h-1.7v3h1.6C287.1,154.4,287.7,153.9,287.8,152.9L287.8,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.9,150.6v6.6h-0.8l-4-4.9v4.9h-0.9v-6.6h0.8l4,5v-5H295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,155.6h-3.5l-0.7,1.7h-1l3-6.6h0.9l3,6.6h-1L302.2,155.6z M301.8,154.8l-1.4-3.2l-1.4,3.2L301.8,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M304.9,150.6h1v5.8h3.6v0.8h-4.5V150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.4,156.6l0.4-0.7c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.6-0.4,1.6-1c0-1.6-4-0.6-4-3.1c0-1,0.8-1.9,2.5-1.9 c0.8,0,1.5,0.2,2.1,0.6L317,152c-0.5-0.3-1.2-0.5-1.8-0.5c-1.1,0-1.6,0.5-1.6,1.1c0,1.6,4,0.6,4,3c0,1-0.8,1.9-2.6,1.9 C314.1,157.4,313.2,157.1,312.4,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.8,156.4v0.8h-4.8v-6.6h4.7v0.8h-3.7v2h3.4v0.8h-3.3v2.1L323.8,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.7,157.3l-1.4-2h-0.4h-1.6v2h-1v-6.6h2.6c1.7,0,2.8,0.9,2.8,2.3c0,0.9-0.6,1.8-1.5,2.1l1.6,2.2H329.7z  M329.7,152.9c0-0.9-0.6-1.5-1.9-1.5h-1.6v3h1.6C329.1,154.4,329.7,153.9,329.7,152.9L329.7,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338,150.6l-2.9,6.6h-0.9l-2.9-6.6h1l2.4,5.5l2.4-5.5H338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.6,156.4v0.8h-4.8v-6.6h4.7v0.8h-3.7v2h3.3v0.8h-3.3v2.1L343.6,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349.6,157.3l-1.4-2h-0.4h-1.6v2h-1v-6.6h2.6c1.7,0,2.8,0.9,2.8,2.3c0,0.9-0.6,1.8-1.5,2.1l1.6,2.2H349.6z  M349.6,152.9c0-0.9-0.6-1.5-1.9-1.5h-1.6v3h1.6C348.9,154.4,349.6,153.9,349.6,152.9L349.6,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.4,167.9v1.3h-5.5v-7.1h5.4v1.3h-3.7v1.5h3.3v1.3h-3.3v1.6H295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.2,169.2l-1.4-2h-1.5v2h-1.6v-7.1h3.1c1.9,0,3.1,1,3.1,2.6c0,1-0.5,1.9-1.5,2.2l1.6,2.3L301.2,169.2z  M299.6,163.5h-1.3v2.5h1.3c1,0,1.5-0.5,1.5-1.2S300.6,163.5,299.6,163.5L299.6,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.6,169.2l-1.4-2h-1.5v2h-1.6v-7.1h3.1c1.9,0,3.1,1,3.1,2.6c0,1-0.5,1.9-1.5,2.2l1.6,2.3L308.6,169.2z  M307.1,163.5h-1.3v2.5h1.3c1,0,1.5-0.5,1.5-1.2S308.1,163.5,307.1,163.5L307.1,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.1,165.7c-0.1-2.1,1.5-4,3.7-4.1c2.1-0.1,4,1.5,4.1,3.7c0.1,2.1-1.5,4-3.7,4.1c-0.1,0-0.1,0-0.2,0 c-2,0.1-3.7-1.4-3.9-3.4C311.1,165.8,311.1,165.7,311.1,165.7z M317.1,165.7c0-1.2-1-2.2-2.3-2.2c-1.2,0-2.2,1-2.2,2.3 c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-0.9,2.2-2.1C317.1,165.8,317.1,165.7,317.1,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.5,169.2l-1.4-2h-1.5v2H320v-7.1h3.1c1.9,0,3.1,1,3.1,2.6c0,1-0.5,1.9-1.5,2.2l1.6,2.3L324.5,169.2z  M323,163.5h-1.3v2.5h1.3c1,0,1.5-0.5,1.5-1.2S324,163.5,323,163.5L323,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M254.9,142.9c-0.9,0-1.6-0.5-2.1-1.2c-0.4-0.7-0.4-1.7,0-2.4l7-11.9c0.4-0.7,1.2-1.2,2.1-1.2l0,0 c0.9,0,1.6,0.5,2.1,1.2l6.8,12c0.4,0.7,0.4,1.7,0,2.4c-0.4,0.7-1.2,1.2-2.1,1.2L254.9,142.9L254.9,142.9z M261.9,126.9L261.9,126.9 c-0.6,0-1.2,0.3-1.5,0.8l-7,11.9c-0.5,0.8-0.2,1.8,0.6,2.3c0.3,0.1,0.5,0.2,0.8,0.2l0,0l13.8,0.1c0.9,0,1.7-0.7,1.7-1.7 c0-0.3-0.1-0.6-0.2-0.8l-6.8-12C263.1,127.2,262.5,126.9,261.9,126.9L261.9,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M260.9,139c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0,0,0,0,0.1c0,0.5-0.4,0.9-0.9,0.9 c0,0,0,0,0,0C261.3,139.9,260.9,139.6,260.9,139C260.9,139.1,260.9,139,260.9,139z M261,131.9h1.7l-0.3,5.4h-1.1L261,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343,142.9c-0.9,0-1.6-0.5-2.1-1.2c-0.4-0.7-0.4-1.7,0-2.4l7-11.9c0.4-0.7,1.2-1.2,2.1-1.2l0,0 c0.9,0,1.6,0.5,2.1,1.2l6.8,12c0.4,0.7,0.4,1.7,0,2.4c-0.4,0.7-1.2,1.2-2.1,1.2L343,142.9L343,142.9z M350,126.9L350,126.9 c-0.6,0-1.2,0.3-1.5,0.8l-7,11.9c-0.5,0.8-0.2,1.8,0.6,2.3c0.3,0.1,0.5,0.2,0.8,0.2l0,0l13.8,0.1c0.9,0,1.7-0.8,1.7-1.7 c0-0.3-0.1-0.6-0.2-0.8l-6.8-12C351.1,127.2,350.5,126.9,350,126.9L350,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M348.9,139c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0.1,0c0.5,0,0.9,0.3,0.9,0.8c0,0,0,0,0,0.1c0,0.5-0.4,0.9-0.9,0.9 c0,0,0,0,0,0C349.3,139.9,348.9,139.6,348.9,139C348.9,139.1,348.9,139,348.9,139z M349,131.9h1.7l-0.3,5.4h-1.1L349,131.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plant--inject-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "608.6,303.8 614.5,342.6 648.8,342.6 656.8,304.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652,328.6c0,0.1-8.8,0.2-19.6,0.2s-19.6-0.1-19.6-0.2s8.8-0.2,19.6-0.2S652,328.6,652,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.1,326.7c0,0.1-8.8,0.2-19.8,0.2s-19.8-0.1-19.8-0.2s8.8-0.2,19.8-0.2S652.1,326.6,652.1,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.1,324.6c0,0.1-8.8,0.2-19.8,0.2s-19.8-0.1-19.8-0.2s8.8-0.2,19.8-0.2S652.1,324.5,652.1,324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M618.5,340.4c-0.5-1.6-0.8-3.2-1-4.9c-0.4-1.6-0.6-3.3-0.7-5c0.5,1.6,0.8,3.2,1,4.9 C618.2,337,618.4,338.7,618.5,340.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M620.8,339.9c-0.2-1.6-0.4-3.2-0.4-4.8c-0.2-1.6-0.2-3.2-0.2-4.8c0.4,1.6,0.6,3.1,0.6,4.8 C621,336.7,621,338.3,620.8,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.1,339.9c-0.8-3.2-1.2-6.5-1.2-9.9C624.4,333.4,624.8,336.6,625.1,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M628.1,340.1c-0.3-1.6-0.5-3.3-0.5-5c-0.1-1.7-0.1-3.3,0.2-5c0.2,1.7,0.3,3.3,0.2,5 C628.1,336.8,628.1,338.5,628.1,340.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633.3,339.9c-0.3-1.6-0.4-3.1-0.4-4.7c-0.1-1.6-0.1-3.2,0-4.7c0.3,1.6,0.4,3.1,0.4,4.7 C633.5,336.8,633.5,338.4,633.3,339.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M637.2,340.1c-0.2-1.6-0.2-3.2-0.2-4.9c-0.1-1.6,0-3.3,0.2-4.9c0.2,1.6,0.2,3.2,0.2,4.9 C637.5,336.9,637.5,338.5,637.2,340.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M640.8,339.6c0.1-3.4,0.4-6.8,1-10.1C641.7,332.9,641.4,336.3,640.8,339.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M645.5,339.1c0-1.5,0.2-2.9,0.6-4.3c0.2-1.4,0.7-2.8,1.3-4.2c-0.2,1.4-0.5,2.9-0.9,4.3 C646.2,336.3,645.9,337.7,645.5,339.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M642.2,227.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.3-0.2,0.5c-0.2,0.5-0.4,1.2-0.7,2.1s-0.7,2-1,3.3 s-0.8,2.8-1.2,4.4s-0.9,3.5-1.3,5.4s-0.9,4-1.3,6.2c-0.8,4.4-1.6,9.3-2.1,14.5s-0.7,10.1-0.8,14.6c0,2.2,0,4.4,0.1,6.4 s0.1,3.9,0.2,5.6s0.2,3.2,0.3,4.6s0.2,2.5,0.3,3.5s0.2,1.6,0.2,2.2c0,0.2,0,0.4,0,0.6s0,0.2,0,0.2c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.3-0.1-0.6c-0.1-0.5-0.2-1.2-0.3-2.2s-0.3-2.1-0.4-3.5s-0.3-2.9-0.4-4.6s-0.2-3.6-0.3-5.6s-0.1-4.1-0.1-6.4 c0-4.5,0.3-9.5,0.8-14.6s1.3-10.1,2.1-14.5c0.5-2.2,0.9-4.3,1.4-6.2s0.9-3.8,1.4-5.4s0.9-3.1,1.3-4.4s0.8-2.4,1.1-3.3 s0.5-1.6,0.7-2.1l0.2-0.5C642.1,227.4,642.2,227.3,642.2,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M636,251.3c0.9-2.8,2.8-5.2,5.3-6.7c0.8-0.6,1.9-0.8,2.8-0.5c1.2,0.6,1.3,2.3,0.9,3.5c-0.6,2.2-2,4-3.9,5.3 c-1.7,1.2-3.8,1.8-5.8,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.9,267.5c0.9-3.4,3.5-8.1,6.3-10.2c0.4-0.4,0.9-0.6,1.4-0.8c0.5-0.2,1.1,0,1.5,0.3 c0.5,0.6,0.6,1.5,0.3,2.2c-1.2,5-5,8.9-10,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.3,281.8c1.4-3.2,3.6-5.9,6.4-8c0.6-0.6,1.4-0.8,2.2-0.8c1.2,0.2,1.8,1.7,1.7,2.9 c-0.2,2.5-2.2,4.5-4.1,6.1c-1.8,1.3-3.8,2.3-5.9,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.7,292c1.3-2.4,3.2-4.5,5.4-6.2c0.5-0.4,1-0.6,1.6-0.7c0.6-0.1,1.2,0.1,1.6,0.6c0.5,0.8,0,1.9-0.6,2.6 c-1.9,2.7-4.6,4.7-7.8,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.4,287.9c-2.3-2.9-4.9-5.5-7.8-7.9c-0.4-0.4-1-0.8-1.5-0.6c-0.4,0.2-0.7,0.6-0.7,1c0,0.4,0.1,0.9,0.3,1.3 c1.9,4.2,5.6,7.3,10,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.6,274.5l-6.1-7.4c-0.5-0.7-1.2-1.4-2-1.9c-1-0.7-2.4-0.5-3.1,0.5c-0.4,0.6-0.5,1.3-0.3,2 c0.2,0.9,0.6,1.7,1.2,2.4c1.2,1.8,2.7,3.4,4.5,4.7c1.8,1.2,3.4,2,5.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M634.5,259.5c-1.2-3.6-3.3-6.7-6.1-9.2c-0.4-0.5-1-0.8-1.6-0.9c-1.3-0.1-2.5,0.8-2.8,2c-0.4,1.4-0.2,2.8,0.6,4 c0.7,1.2,1.7,2.2,2.9,3c2.1,1.6,4.3,2.8,6.8,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M636.9,246c-0.6-4.3-2.8-7.9-5.4-11.4c-0.5-0.7-1.3-1.5-2.2-1.4c-0.6,0.1-1.1,0.5-1.3,1.1 c-0.2,0.6-0.3,1.1-0.2,1.7c0.2,5.3,3.6,10,8.6,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M638.6,239.2c-0.3-2.2-0.4-4.4-0.2-6.7c0.1-2.2,0.9-4.4,2.2-6.2c0.6-0.8,1.3-1.4,2.2-1.8 c0.9-0.4,1.9-0.2,2.7,0.4c0.7,0.6,1,1.5,0.9,2.4c-0.1,0.9-0.3,1.8-0.7,2.6C644.2,233.8,641.5,238.1,638.6,239.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M612,244.3c0,0.2,0,0.4,0,0.5c0,0.4,0,0.9,0,1.6s0,1.5,0,2.5s0,2.1,0.1,3.3c0.1,2.4,0.3,5.3,0.7,8.5 s0.9,6.7,1.7,10.3s1.7,7,2.6,10.1s1.9,5.8,2.8,8.1c0.4,1.1,0.8,2.1,1.2,3s0.7,1.7,1,2.3s0.5,1.1,0.6,1.4c0.1,0.2,0.1,0.3,0.2,0.5 c-0.1-0.2-0.2-0.3-0.3-0.5l-0.7-1.4c-0.3-0.6-0.7-1.4-1-2.3s-0.8-1.9-1.3-3c-0.9-2.2-1.9-5-2.9-8.1s-1.8-6.5-2.6-10.1 s-1.3-7.1-1.7-10.3s-0.6-6.1-0.6-8.5c-0.1-1.2,0-2.3-0.1-3.3s0-1.8,0-2.5s0-1.2,0.1-1.6C611.9,244.7,612,244.5,612,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M613,262c0-2.1,0.8-4.1,2.2-5.7c0.4-0.6,1.1-1,1.8-1c0.9,0.1,1.4,1.3,1.4,2.2c0.1,1.6-0.5,3.2-1.5,4.4 c-0.9,1.2-2.2,2-3.7,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M615.1,273.6c-0.1-2.5,0.7-6.3,2.1-8.3c0.2-0.3,0.5-0.6,0.8-0.8c0.3-0.2,0.8-0.3,1.1-0.1 c0.5,0.3,0.7,0.9,0.7,1.4c0.3,3.6-1.5,7.1-4.6,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M617.7,283.4c0.3-2.5,1.2-4.8,2.6-6.8c0.3-0.5,0.8-0.9,1.3-1c0.9-0.1,1.6,0.8,1.8,1.6c0.4,1.8-0.5,3.6-1.5,5 c-1,1.3-2.1,2.4-3.4,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M620.2,290.3c0.4-1.9,1.2-3.8,2.4-5.4c0.3-0.4,0.6-0.7,1-0.9c0.4-0.2,0.9-0.2,1.2,0.1c0.5,0.4,0.4,1.3,0.2,1.9 c-0.7,2.2-2.1,4.2-4,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M619.1,287.5c-2.2-1.5-4.6-2.7-7-3.7c-0.4-0.2-0.8-0.2-1.2-0.1c-0.3,0.2-0.4,0.5-0.3,0.9 c0.1,0.3,0.3,0.6,0.5,0.8c2.2,2.4,5.4,3.8,8.6,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M616.4,278.4l-5.8-3.8c-0.5-0.4-1.1-0.7-1.8-0.9c-0.8-0.3-1.7,0.1-2,1c-0.2,0.5-0.1,1,0.2,1.4 c0.3,0.6,0.8,1,1.3,1.4c1.2,1,2.6,1.8,4,2.3c1.3,0.6,2.8,0.6,4.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M613.7,267.9c-1.6-2.2-3.7-3.9-6.2-5c-0.4-0.2-0.8-0.3-1.3-0.3c-0.9,0.2-1.5,1-1.5,1.9c0,1,0.5,2,1.2,2.6 c0.8,0.7,1.7,1.1,2.6,1.5c1.7,0.6,3.6,0.9,5.4,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M612.5,258.3c-1.3-2.8-3.6-4.8-6.2-6.6c-0.5-0.5-1.2-0.6-1.8-0.5c-0.4,0.2-0.6,0.6-0.6,1 c0,0.4,0.1,0.8,0.2,1.2c1.3,3.6,4.6,6,8.5,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M612.2,253.2c-0.7-1.4-1.2-2.9-1.6-4.5c-0.4-1.6-0.3-3.2,0.2-4.7c0.2-0.7,0.6-1.2,1.1-1.7 c0.5-0.4,1.3-0.6,1.9-0.3c0.6,0.3,1,0.8,1.2,1.4c0.1,0.6,0.2,1.3,0.1,1.9C614.9,248.4,613.9,251.9,612.2,253.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.4,244c0,0.2,0.1,0.4,0,0.5c0,0.4,0,0.9,0.1,1.6s0,1.5,0,2.5s0,2.1-0.1,3.3c-0.1,2.4-0.3,5.3-0.6,8.5 s-0.9,6.7-1.7,10.3s-1.7,7.1-2.6,10.1s-1.9,5.8-2.8,8.1c-0.4,1.1-0.9,2.1-1.3,3s-0.7,1.6-1,2.3s-0.5,1-0.7,1.4 c-0.1,0.2-0.2,0.3-0.3,0.5c0-0.2,0.1-0.4,0.2-0.5c0.2-0.4,0.4-0.8,0.6-1.4s0.6-1.4,1-2.3s0.8-1.9,1.2-3c0.9-2.3,1.8-5,2.8-8.1 s1.8-6.5,2.6-10.1s1.3-7.1,1.7-10.3s0.6-6.1,0.7-8.5c0.1-1.2,0.1-2.3,0.1-3.3s0-1.8,0-2.5s0-1.2,0-1.6 C655.3,244.3,655.4,244.1,655.4,244z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M654.4,261.6c0-2.1-0.8-4.1-2.2-5.7c-0.4-0.6-1.1-1-1.8-1c-0.9,0.1-1.4,1.3-1.4,2.2c0,1.6,0.5,3.2,1.5,4.4 c0.9,1.2,2.2,2,3.7,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M652.4,273.1c0.1-2.5-0.7-6.3-2.1-8.3c-0.2-0.3-0.5-0.6-0.8-0.8c-0.3-0.2-0.8-0.3-1.1-0.1 c-0.5,0.3-0.7,0.9-0.7,1.4c-0.3,3.6,1.5,7.1,4.6,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M649.7,283c-0.2-2.5-1.2-4.8-2.6-6.9c-0.3-0.5-0.8-0.9-1.3-1c-0.9-0.1-1.6,0.8-1.8,1.6 c-0.4,1.8,0.5,3.6,1.5,5.1c1,1.3,2.1,2.4,3.4,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M647.2,289.9c-0.4-1.9-1.2-3.8-2.4-5.4c-0.3-0.3-0.6-0.6-1-0.9c-0.4-0.2-0.9-0.2-1.2,0.1 c-0.5,0.4-0.4,1.3-0.2,1.9c0.7,2.2,2.2,4.2,4.1,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M648.3,287.1c2.2-1.4,4.6-2.7,7-3.7c0.4-0.2,0.8-0.2,1.2-0.1c0.3,0.2,0.4,0.6,0.3,0.9 c-0.1,0.3-0.3,0.6-0.5,0.8c-2.2,2.4-5.4,3.7-8.6,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M651,278l5.8-3.8c0.5-0.4,1.1-0.7,1.8-0.9c0.6-0.2,1.3,0,1.8,0.5c0.4,0.6,0.4,1.3,0,1.9 c-0.3,0.6-0.8,1-1.3,1.4c-1.2,1-2.5,1.8-4,2.3c-1.3,0.6-2.8,0.6-4.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.7,267.6c1.6-2.2,3.7-3.9,6.2-5c0.4-0.2,0.8-0.3,1.3-0.3c0.9,0.2,1.5,1,1.5,1.9c0,1-0.5,2-1.2,2.6 c-0.8,0.7-1.7,1.1-2.6,1.5c-1.7,0.6-3.6,1-5.4,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M654.9,257.9c1.3-2.8,3.6-4.8,6.2-6.6c0.5-0.5,1.2-0.6,1.8-0.5c0.4,0.2,0.6,0.6,0.6,1c0,0.4-0.1,0.8-0.2,1.2 c-1.3,3.6-4.6,6.1-8.5,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.2,252.9c0.7-1.4,1.2-3,1.6-4.5c0.4-1.6,0.3-3.2-0.2-4.7c-0.2-0.7-0.6-1.2-1.1-1.7 c-0.5-0.4-1.3-0.6-1.9-0.3c-0.6,0.3-1,0.8-1.2,1.4c-0.1,0.6-0.2,1.3-0.1,1.9C652.6,248,653.5,251.5,655.2,252.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M604.7,296.1v7.2c0,1.6,1.3,2.9,2.9,2.9h49.7c1.6,0,2.9-1.3,2.9-2.9v-7.2H604.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "609,306.2 609.4,308.5 655.2,311.8 656.4,306.2  "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Floor--inject-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M685.5,343c0,0.1-152.8,0.3-341.2,0.3S3,343.1,3,343s152.8-0.3,341.3-0.3S685.5,342.8,685.5,343z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character--inject-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.3,132.6h1.2c11.5-0.1,21.2,8.6,22.2,20.1c0.9,10.5,1.6,22.2,1.6,27.8c-0.2,11.7-12.2,13.5-12.2,13.5 l0.4,10.4c0.3,7.8-5.7,14.3-13.5,14.8l0,0c-7.9,0.5-14.6-5.6-15.1-13.4c0-0.1,0-0.1,0-0.2l-2.5-49.4 C94.4,144,100.8,133.2,113.3,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M126.2,193.9c-5.6,0-11-1.6-15.7-4.5c0,0,3.7,8.4,15.7,7.4L126.2,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.2,161.2c0,0.9-0.7,1.7-1.7,1.7c-0.9,0.1-1.7-0.6-1.8-1.5c0,0,0,0,0,0c0-0.9,0.7-1.7,1.6-1.7 C133.3,159.6,134.1,160.2,134.2,161.2C134.2,161.1,134.2,161.1,134.2,161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.1,158.4c-0.2,0.2-1.5-0.7-3.4-0.7s-3.2,0.9-3.4,0.7s0.1-0.5,0.7-0.9c0.8-0.5,1.8-0.8,2.7-0.8 c1,0,1.9,0.3,2.7,0.9C134,157.9,134.2,158.3,134.1,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.2,161.2c0,0.9-0.7,1.7-1.6,1.7c-0.9,0.1-1.7-0.6-1.8-1.5c0,0,0,0,0,0c0-0.9,0.7-1.7,1.7-1.7 C116.4,159.6,117.2,160.2,117.2,161.2C117.2,161.1,117.2,161.1,117.2,161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.9,158.6c-0.2,0.2-1.5-0.7-3.4-0.7s-3.2,0.9-3.4,0.7s0.1-0.5,0.7-0.9c0.8-0.5,1.8-0.8,2.7-0.8 c1,0,1.9,0.3,2.7,0.9C116.8,158.2,117,158.6,116.9,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.7,172c1-0.3,2-0.5,3-0.5c0.5,0,0.9-0.1,1-0.4c0-0.5-0.1-0.9-0.3-1.4c-0.4-1.1-0.9-2.3-1.4-3.5 c-1.9-5-3.3-9.1-3.1-9.1s1.9,3.9,3.9,8.9l1.3,3.5c0.3,0.6,0.4,1.2,0.2,1.8c-0.1,0.3-0.4,0.6-0.8,0.7c-0.3,0.1-0.5,0.1-0.8,0.1 C124.7,172.1,123.7,172.1,122.7,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.2,153.7c0-0.5,1.8-1,3.7-2s3.3-2.2,3.8-1.9c0.2,0.1,0.1,0.7-0.4,1.4c-1.3,1.8-3.4,2.9-5.7,3 C107.7,154.1,107.2,153.9,107.2,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129,152.1c0.5-0.2,1.5,0.6,2.9,1.3s2.7,0.9,2.8,1.4c0,0.2-0.3,0.5-1,0.7c-0.9,0.1-1.8,0-2.6-0.4 c-0.8-0.4-1.5-1-2-1.7C128.8,152.7,128.8,152.2,129,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M97.2,164.8c-0.2-0.1-8.2-2.4-8,5.6s8.4,6.1,8.4,5.9S97.2,164.8,97.2,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M95.8,173.3c0,0-0.1,0.1-0.4,0.2c-0.3,0.1-0.7,0.2-1.1,0.1c-0.9-0.3-1.7-1.6-1.7-3.1c0-0.7,0.1-1.4,0.3-2 c0.1-0.5,0.5-0.9,1-1.1c0.3-0.1,0.7,0.1,0.8,0.4c0.1,0.2,0.1,0.4,0.1,0.4s0.2-0.1,0.1-0.5c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.2-0.2-0.5-0.2-0.8-0.2c-0.7,0.1-1.2,0.6-1.5,1.3c-0.3,0.7-0.5,1.5-0.4,2.2c0.1,1.6,1,3.1,2.2,3.4c0.5,0.1,0.9,0,1.3-0.2 C95.8,173.5,95.9,173.3,95.8,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.7,141l34.2,0.7c-1.2-2.3-2.9-4.2-5-5.7c-4.5-3.4-9.9-5.3-15.5-5.4c-5.6-0.1-16.9,6.5-21,10.3 c-3.2,3-3.2,5.6-3.2,5.6c-0.5,4.3,2,9.2,3,13.5c0.5,2.2,1.5,8.8,1.5,8.8l0,0c1.9,0,2.6-1.5,2.3-3.3l-0.4-7.1 c3.9-2.9,5.2-8.1,3.4-12.6C101.4,145.2,100.4,142.2,102.7,141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.8,166.3c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2 C110,166.1,110,166.3,109.8,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.4,165.6c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.2 C113.6,165.4,113.5,165.5,113.4,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M115.7,165.4c-0.1,0-0.2-0.1-0.2-0.3s0.1-0.3,0.2-0.4s0.2,0.1,0.2,0.3S115.9,165.4,115.7,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.6,168.4c-0.1,0-0.2-0.1-0.2-0.1s0.1-0.1,0.2-0.1s0.2,0.1,0.2,0.1S111.7,168.4,111.6,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.8,167.7c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0 C115,167.6,114.9,167.7,114.8,167.7C114.8,167.7,114.8,167.7,114.8,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.6,165.8c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0.2-0.3c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0 C131.8,165.6,131.7,165.8,131.6,165.8C131.6,165.8,131.6,165.8,131.6,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M134,165.6c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.2,0.1,0.2,0.2 C134.2,165.4,134.2,165.5,134,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M129.5,165.8c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0.1 c0,0,0,0,0,0C129.7,165.7,129.6,165.8,129.5,165.8C129.5,165.8,129.5,165.8,129.5,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.2,168.2c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0.1c0,0,0,0,0,0 C131.4,168,131.4,168.1,131.2,168.2C131.3,168.2,131.3,168.2,131.2,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M133.3,167.8c-0.1,0-0.2-0.1-0.1-0.2c0-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.1,0.2 C133.5,167.8,133.4,167.8,133.3,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.1,141.4c-0.8-3-0.1-6.2,1.9-8.6c2-2.4,5-3.8,8.2-3.7c1.6,0.2,3.2,0.3,4.8,0.3c3-0.3,5.2-2.6,8-3.8 c4.4-1.7,9.5-0.2,12.3,3.6c1,1.5,1.7,3.4,3.3,4.3c1.4,0.8,3.1,0.8,4.7,1.2c3.2,1,5.2,4,5.1,7.3c-0.3,3.3-2.4,6.1-5.5,7.3 c-3.1,1.2-6.6,0.9-9.5-0.6c-2.6-1.4-4.9-3.8-7.8-3.7s-5.7,2.9-8.7,2.3c-1.6-0.3-2.8-1.5-3.9-2.6s-2.5-2.2-4.1-2.3s-2.4,2-1.9,3.5 L95.1,141.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.2,137.6c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.6,0.8-1,1.1c-0.6,0.5-1.3,0.9-2,1.1 c-1,0.3-2.1,0.4-3.1,0.2c-1.3-0.2-2.4-0.9-3.3-1.8c-0.8-1.1-1.6-2.3-2.4-3.5c-0.4-0.6-1-1.1-1.6-1.5c-0.7-0.3-1.5-0.5-2.3-0.5 c-0.8,0-1.6,0.2-2.3,0.6c-0.7,0.4-1.3,1-1.7,1.7c-0.4,0.8-0.8,1.5-1.2,2.2c-0.5,0.8-1.3,1.2-2.2,1.3c-0.8,0-1.7-0.2-2.4-0.7 c-0.7-0.4-1.3-0.9-1.8-1.5c-0.9-1.1-2.1-1.9-3.4-2.4c-1.2-0.2-2.4,0.1-3.4,0.8c-0.8,0.6-1.5,1.4-1.9,2.3c-0.3,0.7-0.6,1.4-0.7,2.1 c-0.1,0.6-0.2,1.1-0.2,1.4c0,0.2,0,0.3-0.1,0.5v-0.1c0-0.1,0-0.2,0-0.4c0-0.5,0.1-1,0.2-1.4c0.1-0.8,0.3-1.5,0.7-2.2 c0.4-1,1.1-1.8,1.9-2.4c1-0.8,2.4-1.1,3.6-0.9c1.4,0.5,2.6,1.3,3.5,2.4c0.5,0.5,1.1,1,1.8,1.4c0.7,0.4,1.4,0.6,2.2,0.6 c0.8-0.1,1.5-0.5,1.9-1.2c0.5-0.7,0.8-1.5,1.2-2.2c0.4-0.8,1.1-1.4,1.9-1.9c0.8-0.4,1.6-0.6,2.5-0.6c1.7-0.1,3.2,0.7,4.2,2.1 c0.7,1.2,1.5,2.4,2.3,3.5c0.8,0.9,1.9,1.5,3.1,1.8c1,0.2,2,0.2,3-0.1c0.7-0.2,1.4-0.6,2-1.1C135.4,138.6,135.9,138.1,136.2,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.4,137.6c0.1,0.2,0.1,0.4,0.1,0.6c0.1,0.6,0,1.2-0.2,1.8c-0.3,0.9-0.7,1.7-1.3,2.4 c-0.7,0.8-1.7,1.5-2.7,1.9c-1.9,0.8-4,1-6,0.6c-0.6-0.1-1.2-0.2-1.8-0.3c-0.2,0-0.4-0.1-0.6-0.2c0-0.1,0.9,0.2,2.5,0.3 c2,0.2,4,0,5.8-0.7c1-0.4,1.9-1,2.6-1.8c0.6-0.6,1-1.4,1.3-2.2C142.4,139.2,142.5,138.4,142.4,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M121.1,174.8c-0.8-0.5-1.7-1-2.6-1.3c-0.6-0.2-1.3-0.1-1.8,0.4c-0.4,0.4-0.6,0.9-0.6,1.4 c-0.1,0.7,0,1.3,0.4,1.9c0.5,0.6,1.1,0.9,1.8,1.1c0.6,0.3,1.2,0.3,1.8,0.2c0.6-0.2,1-0.8,1.1-1.4 C121.4,176.4,121.3,175.6,121.1,174.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.9,178.4c-0.6,0.1-1.1-0.1-1.6-0.4c-0.6-0.3-1-0.8-1.3-1.3c-0.4-0.7-0.3-1.6,0.1-2.3 c0.2-0.4,0.6-0.7,1-0.8c0.4-0.1,0.8-0.2,1.1-0.1c0.6,0.1,1.2,0.4,1.7,0.7c0.8,0.5,1.4,0.7,1.4,0.8s-0.7,0-1.6-0.5 c-0.5-0.3-1-0.4-1.6-0.6c-0.6-0.1-1.3,0.1-1.6,0.7c-0.3,0.5-0.4,1.2-0.1,1.8c0.2,0.5,0.6,0.9,1,1.2 C118.2,178.2,118.9,178.3,118.9,178.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.1,155c-0.1,0-0.2-0.9-0.2-1.9s0-1.9,0.2-1.9s0.3,0.9,0.3,1.9S105.2,155,105.1,155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.9,155.5c-0.4-1.6-0.4-3.2-0.1-4.8C104.2,152.3,104.3,153.9,103.9,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.2,344.9c-0.9,0.3-1.6,0.9-2.2,1.7l-1.5,1.9c-1.1,1.4-1.3,3.2-0.8,4.8l0,0c0.7,2,2.7,3.3,4.9,3.3l44.3-1 l-4.4-17.8l-1.9-5.1l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65.8,356.2c0.1,0-0.2-1.3-0.1-2.9s0.8-2.8,0.6-2.9C65,352.1,64.8,354.4,65.8,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.4,355.3c0.1-0.8,0.3-1.6,0.6-2.4c0.4-0.7,0.8-1.5,1.3-2.1c-0.1-0.1-1.2,0.5-1.7,2 C69.1,353.5,69.1,354.4,69.4,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.7,356.5c0.1,0-0.2-1.4,0-3.2s0.8-3,0.6-3.1c-0.7,0.9-1.1,2-1.1,3.1C60,354.3,60.2,355.5,60.7,356.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.2,356.4c-0.2-1-0.3-2.1-0.3-3.1c0.2-1,0.5-2,1-3c0,0-0.3,0.2-0.7,0.7c-0.4,0.7-0.7,1.4-0.8,2.2 c-0.1,0.8,0,1.6,0.3,2.3C55.9,356.1,56.1,356.4,56.2,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.6,336.2v0.5C85.6,336.7,86.2,336.1,85.6,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.3,336.3L85.3,336.3L85.3,336.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.2,336.4l-0.3,0.1L85.2,336.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.6,337.1l-21.7,7.1c-1.2,0.4-2.3,1-3.3,1.8c-1.8,1.6-3.3,4.3-2.4,6.8c1.2,3.3,3.2,3.5,3.2,3.5 s-2.4-3-1.7-5.2s3.3-4.3,6.5-5.6l35.1-9l0.2-0.1v-3.6L69.6,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85,336.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.7,356.8c0.6-1.8,1-3.8,0.9-5.8c-0.2-1.9-0.8-3.8-1.7-5.6c0.4,0.4,0.8,0.9,1,1.4c0.7,1.3,1,2.7,1.1,4.1 c0.1,1.4-0.1,2.9-0.6,4.2C52.3,355.8,52,356.3,51.7,356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.3,342.8c-1.4-0.1-2.7-0.6-3.7-1.6c-1.1-0.8-1.9-2-2.2-3.3c0.8,1,1.6,2,2.6,2.9 C83,341.6,84.1,342.3,85.3,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.5,132.6c0.2-1.4,1-2.6,2.2-3.4c0.1,0.7,0.2,1.3,0.4,2c1.1-1.6,2.8-2.6,4.7-2.6l-1.4,2.6 c1-0.4,2.1-0.5,3.1-0.4c-0.6,1.1-1.5,1.9-2.5,2.6c-1,0.7-1.8,1.7-2.1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M191.7,200.8l-44.4,36.6c-0.8-0.6-14.3-27.2-14.3-27.2l38.8-23.1l-33.3-29.9l8.6-6.5l42.2,23.6 c4.8,2.7,7.9,7.7,8.3,13.2l0,0C197.9,192.6,195.7,197.6,191.7,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.8,159l6.9-7.9l0,0l-8.9-8.3l-2.3-5.9c0.4-2-0.9-3.9-2.9-4.3c-0.1,0-0.2,0-0.3,0l-7.2-0.5 c0,0-3.4-0.2-3.1,2c0.1,0.4,0.3,0.7,0.7,0.8l-0.7,1.2c-0.1,2,2.5,2.2,2.5,2.2l6,0.6l1.2,3.2c0,0-7.2-3.3-8.4-2s12.2,8.1,12.2,8.1 l0.5,8.7l1.4,0.5L140.8,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M136.4,137.2c-0.3-0.5-0.8-1-1.3-1.4c-0.6-0.4-1.2-0.6-1.9-0.7c-0.8-0.1-1.7-0.1-2.6-0.1 c-2.2,0.1-4.5,0.1-6.7-0.1c2.2-0.3,4.5-0.4,6.7-0.4c0.9,0,1.8,0,2.7,0.1c0.7,0.1,1.4,0.4,2,0.9 C136.3,136.3,136.4,137.2,136.4,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M138.4,145.7c-0.1,0-0.3-0.3-0.7-0.7c-0.6-0.6-1.3-1-2-1.4c-1.1-0.5-2.2-1-3.2-1.6c1.2,0.1,2.4,0.5,3.5,1.2 c0.8,0.4,1.5,0.9,2.1,1.6C138.4,145.3,138.5,145.7,138.4,145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M143.2,161.5c-0.5-0.3-1-0.7-1.4-1.1c-0.9-0.7-2.1-1.8-3.4-3h0.2c-0.8,0.2-1.6-0.2-2-0.9 c-0.3-0.5-0.4-1.1-0.4-1.8c0-0.6,0-1.1,0-1.6c0-0.9,0.1-1.8,0.1-2.7c0-0.8,0.1-1.6,0.2-2.4c0.1,0.8,0.2,1.6,0.1,2.5 c0,0.8,0,1.7,0,2.7c-0.1,1,0,2.1,0.3,3.1c0.3,0.5,0.8,0.8,1.4,0.7l0.1-0.1l0.1,0.1c1.3,1.2,2.5,2.3,3.3,3.1 C142.5,160.5,142.9,160.9,143.2,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M179.6,194.6c-1.4-1.1-2.8-2.3-4-3.6c-2.1-2.1-4-3.5-4-3.6s2.2,1.2,4.3,3.3 C177.2,191.7,178.5,193.1,179.6,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.2,138.7c0.5-0.6,1.2-1.2,2-1.5c0.8-0.3,1.7-0.2,2.4,0.3c0.5,0.4,0.8,1,1.3,1.4c0.7,0.5,1.6,0.6,2.4,0.2 c0.8-0.3,1.4-0.8,2-1.4c0.2-0.2,0.4-0.4,0.6-0.2c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.7-0.1,1.5-0.4,2.1c0.3,0.1,0.7,0,1-0.1 c0.3,0.9-0.2,1.9-1.2,2.3c-0.9,0.3-1.9,0.3-2.8,0c-2.2-0.4-4.2-1.2-6.1-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.3,221.4c-0.6-12.3,5.1-24.1,15-31.4c1.4,12.5-4.2,24.8-14.6,31.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3,221.4c-0.6-12.3,5.1-24.1,15-31.4c1.4,12.5-4.2,24.8-14.6,31.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M85.6,209.1l-25.1-22.3L91,156.1l-11.9-8.7c0,0-35.9,27.1-43.1,34.7c-3.4,3.6-4.6,12.8-0.5,17 c10.7,10.9,32.1,30.4,32.1,30.4L85.6,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.8,141.8l-10.5-1.7l6.1-3.1l2.9-0.1c-0.4-1.8-2-3.2-3.9-3.3c-3.3-0.2-3.8,0.4-3.8,0.4s-1.6-3.4-2.5-3.7 c-1.3-0.4-2.6-0.6-3.9-0.6c-1,0.4-2,1-2.8,1.8c0,0-3.9-2.1-4.8-0.8c-0.9,1.7-1.6,3.5-2.2,5.3l-5.4,5.2l-0.9,0.6l-15.8,12.4 l11.3,11.3l13.7-14l2.2,0.7c1.2,0.2,2.4-0.2,3.2-1c0.8-0.7,1.6-1.5,2.3-2.4c0.5-0.7,1.5-2.4,1.7-2.6c0.5-0.5,1.1-0.9,1.8-1.2 c0,0,11.1-0.1,12-0.7S120.6,142.2,117.8,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M103.4,136.4c0.9-0.7,1.8-1.3,2.9-1.6c1-0.6,2.1-0.9,3.2-0.9c-1,0.5-2,1-3,1.4 C105.5,135.8,104.5,136.2,103.4,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M105.8,133.2c0.1,0,0.1,0.6-0.1,1.3s-0.5,1.2-0.6,1.2s-0.1-0.6,0.1-1.3S105.7,133.1,105.8,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M96.2,135.6c0.4-0.9,1-1.7,1.7-2.4c1-1.2,1.9-2.1,2.1-2c-0.4,0.9-1,1.7-1.6,2.4 C97.2,134.7,96.4,135.6,96.2,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.6,142.6c0,0,0,0.1,0,0.3c0,0.3-0.1,0.5-0.2,0.8c-0.1,0.4-0.5,0.7-0.9,0.9c-0.5,0.2-1.1,0.3-1.6,0.3 c-1.2,0.1-2.6,0.2-4.2,0.2s-3.3,0-5.1,0.2c-0.8,0-1.7,0.3-2.4,0.8c-0.6,0.5-1.1,1.1-1.4,1.8c-0.7,1.3-1.6,2.4-2.7,3.3 c-0.8,0.6-1.7,1-2.6,1.1c-0.3,0.1-0.7,0.1-1,0c0,0,0.4,0,1-0.2c0.9-0.2,1.7-0.6,2.4-1.2c1-0.9,1.9-2,2.5-3.2c0.4-0.8,0.9-1.4,1.6-2 c0.8-0.5,1.7-0.8,2.6-0.9c1.8-0.2,3.6-0.1,5.1-0.1s3,0,4.1-0.1c0.5,0,1-0.1,1.6-0.2c0.4-0.1,0.7-0.4,0.8-0.8 C119.5,143,119.5,142.6,119.6,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62,184.8c-0.4,0.6-0.8,1.2-1.4,1.7c-0.9,1-2.2,2.3-3.6,3.7s-2.7,2.7-3.7,3.6c-0.5,0.5-1,1-1.6,1.4 c0.4-0.6,0.9-1.2,1.4-1.7c0.9-1,2.2-2.3,3.6-3.7s2.7-2.7,3.7-3.6C60.9,185.6,61.4,185.2,62,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.7,135.1c-1.4-1-2.3-2.5-2.7-4.1l1.4,1c-0.8-2-0.7-4.2,0.3-6.1l2.4,4c0.1-0.9,0.7-1.7,1.5-2.1 c-0.1,2.1,0.2,4.2,1.1,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.6,132.6c-1.1-1-1.9-2.2-2.5-3.6c0.2-0.1,0.5,0.1,0.7,0.2s0.5,0.2,0.7,0.1s0.1-0.4,0-0.6 c-0.4-1-0.3-2.2,0.2-3.1l2.8,5.2L98.6,132.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M236.5,361.5c-2.1-7-4.8-14-15.3-20.1l-10-5.1l0.8,0.3L167.7,314h-0.6l-13.4-6.8l-39.6,1.5l-2.7,8.9l-25.9,1.7 l-0.6,20.3v8.5c-4.5-4.5-14.7,0.5-14.7,7.9l26,37.2c13,21.1,42.9,13.9,42.9,13.9l0.4-0.2c9.2-5.2,13.8-16,11-26.2l-1.2-4.6l0.2,0.6 l-0.4-4.5l0.2,0.1l41.3,10.9c16.4,2.7,27.2,5.9,38.3-1c2.1-1.3,3.8-2.9,5.2-4.9C237.4,372.7,238.2,366.8,236.5,361.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.8,376.7c0.4,0,0.7-0.1,1.1-0.2c0.9-0.2,1.9-0.6,2.7-1.1c6-3.2,8.3-10.7,5.1-16.7c-0.4-0.9-1-1.7-1.6-2.4 c-0.2-0.3-0.5-0.5-0.8-0.7c0.8,1,1.5,2.1,2.1,3.3c2.9,5.9,0.7,13-5,16.3C226.2,375.7,225,376.3,223.8,376.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.2,397c-0.6-3.2-1.3-6.3-2.2-9.5c-0.7-3.2-1.6-6.3-2.7-9.3c0.6,3.2,1.3,6.3,2.2,9.5 C104.9,392.8,106,397,106.2,397z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.1,385.3c0.1,0.7,0.2,1.4,0.5,2.1c1.2,3.3,3.1,6.2,5.7,8.4c0.5,0.5,1.1,0.9,1.7,1.2 c-1.7-1.6-3.3-3.4-4.7-5.4C105.1,389.6,104,387.5,103.1,385.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123.7,403.1c0.3,0.1,0.5,0.2,0.8,0.2c0.8,0.1,1.5,0.1,2.3,0.1c5.2-0.3,9.8-3.4,12-8.1 c0.3-0.7,0.6-1.4,0.8-2.2c0.1-0.3,0.1-0.5,0.1-0.8c-0.1,0-0.3,1.1-1.2,2.8c-1.1,2.2-2.8,4.1-4.8,5.5c-2.1,1.4-4.4,2.2-6.9,2.4 C124.9,403.2,123.7,403,123.7,403.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.9,334.8c0.5-0.2,0.9-0.4,1.4-0.7c1.2-0.6,2.4-1.2,3.7-1.7c8.5-3.3,18.1-2.5,25.9,2.2 c1.2,0.7,2.3,1.4,3.4,2.3c0.4,0.3,0.8,0.6,1.2,0.9c0,0-0.1-0.1-0.3-0.3s-0.4-0.5-0.8-0.8c-1-0.9-2.2-1.7-3.3-2.4 c-7.9-4.9-17.6-5.7-26.2-2.2c-1.3,0.5-2.5,1.1-3.7,1.8c-0.4,0.2-0.7,0.5-0.9,0.6S100.9,334.7,100.9,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.2,321.1c-0.6,0.6-1.1,1.3-1.5,2c-2.1,3.4-3.3,7.4-3.2,11.4c0,0.8,0.1,1.7,0.3,2.5c0-2.8,0.3-5.6,1-8.3 C147.6,326,148.8,323.5,150.2,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.2,379.5c-0.3-0.3-0.6-0.7-0.8-1.1c-0.5-0.8-1.2-1.9-2-3.2c-1.6-2.8-3.7-6.6-5.9-11s-4.1-8.4-5.5-11.2 c-0.6-1.4-1.2-2.5-1.6-3.4c-0.2-0.4-0.4-0.8-0.5-1.3c0.3,0.4,0.5,0.8,0.7,1.2c0.4,0.8,1,1.9,1.7,3.4c1.5,3,3.4,6.9,5.6,11.2 s4.2,8.2,5.8,11l1.8,3.3C100.8,378.6,101.1,379,101.2,379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.5,377.5c-0.2,0-0.4-0.1-0.5-0.1l-1.5-0.4l-5.6-1.5l-18.4-5.2l-18.4-5.2l-5.6-1.6l-1.5-0.4 c-0.2,0-0.4-0.1-0.5-0.2c0.2,0,0.4,0,0.6,0.1c0.4,0.1,0.9,0.1,1.6,0.3c1.3,0.3,3.3,0.8,5.6,1.4c4.7,1.2,11.3,3,18.5,5.1 s13.7,4,18.4,5.4l5.6,1.7l1.5,0.5C200.1,377.3,200.3,377.4,200.5,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.1,319.9c0.2,1,0.3,1.9,0.3,2.9c0.1,1.8,0.3,4.3,0.5,7s0.2,5.2,0.2,7c0,0.7,0,1.4-0.1,2.1 c0,0.3-0.1,0.5-0.2,0.8c0,0,0-0.3,0-0.8s0-1.2,0-2.1c-0.1-2-0.2-4.4-0.4-7s-0.3-5.2-0.3-7C141,321.9,141,320.9,141.1,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M135.4,322.3c0,0,0.1-0.2,0.4-0.3c0.5-0.1,1-0.1,1.4,0.1c0.7,0.3,1.1,1,1.2,1.8c0,0.4-0.1,0.9-0.3,1.3 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.9,0.3-1.9-0.1-2.4-0.9c-0.4-0.6-0.4-1.5-0.1-2.1c0.2-0.4,0.6-0.7,1-1c0.3-0.1,0.5-0.2,0.5-0.2 s-0.1,0.1-0.4,0.3c-0.4,0.2-0.6,0.6-0.8,0.9c-0.2,0.6-0.2,1.2,0.1,1.7c0.4,0.6,1.2,0.9,1.9,0.6c0.7-0.2,1.2-0.9,1.1-1.6 c0-0.6-0.3-1.2-0.8-1.5C136.5,322.3,136,322.2,135.4,322.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.8,342c0.3,0.4,0.5,0.9,0.7,1.4c0.4,0.9,0.9,2.2,1.5,3.9c1.2,3.3,2.7,8,4.2,13.1s2.7,9.9,3.6,13.3 c0.4,1.6,0.7,3,1,4c0.1,0.5,0.2,1,0.3,1.5c-0.2-0.5-0.4-1-0.5-1.5c-0.3-1-0.7-2.4-1.1-4c-1-3.5-2.3-8.1-3.7-13.3s-2.9-9.8-4.1-13.1 c-0.6-1.7-1-3-1.4-3.9C139,343,138.9,342.5,138.8,342z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.7,377.8c0.4-0.8,0.2-1.7-0.4-2.3c-0.7-0.7-1.7-1.1-2.6-1.2l-3.9-0.8c-7.5-1.7-14.9-3.9-22.2-6.5 c-7.3-2.6-14.3-5.7-21.2-9.3c-1.3-0.7-2.5-1.3-3.5-1.9s-1.9-1.1-2.6-1.5l-1.6-1c-0.2-0.1-0.4-0.2-0.6-0.4c0.2,0.1,0.4,0.2,0.6,0.3 l1.7,0.9c0.7,0.4,1.6,0.9,2.7,1.4s2.2,1.2,3.6,1.8c6.9,3.5,14,6.5,21.2,9.1c7.2,2.6,14.6,4.9,22.1,6.7l3.9,0.9c1,0.1,2,0.6,2.7,1.3 c0.4,0.5,0.6,1.2,0.6,1.8C201,377.4,200.9,377.6,200.7,377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.9,263.9c0.1,0.1,0.2,0.2,0.3,0.3l0.9,0.9c0.4,0.4,0.9,0.9,1.5,1.4s1.3,1.1,2.1,1.7s1.7,1.2,2.7,1.9 s2.1,1.2,3.2,1.9c2.5,1.3,5.2,2.4,7.9,3.3c2.7,0.8,5.5,1.4,8.4,1.8c1.3,0.1,2.6,0.3,3.7,0.3s2.2,0,3.2,0s1.9-0.1,2.7-0.2 c0.7,0,1.3-0.1,2-0.2l1.3-0.2c0.1,0,0.3-0.1,0.4-0.1c-0.1,0-0.3,0-0.4,0l-1.3,0.1c-0.5,0.1-1.2,0.1-2,0.2s-1.7,0.1-2.7,0.1 s-2.1,0-3.2-0.1s-2.4-0.2-3.7-0.3c-2.8-0.4-5.6-1-8.3-1.8c-2.7-0.9-5.3-2-7.8-3.2c-1.1-0.6-2.2-1.2-3.2-1.8s-1.9-1.2-2.7-1.8 s-1.5-1.1-2.1-1.6s-1.1-0.9-1.6-1.3l-1-0.8C98.1,264,97.9,263.9,97.9,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M150.6,273.9l-0.7-9.5l0.8-26.3l23.8-18.7c-1.1-8.5-14.4-25.7-14.4-25.7l-20.3,8h-3.4l-3,2.9l-6.9-0.9 c-2.7,13.3-19.5,11.5-28.6,0.7l-9.9,0.9l-3.6-3.3l-5.1,1.4L65.3,190c-0.3,14.1-5.5,24.2-15,31.5L70.4,243l5,5 c1.8,26.4,3.6,51.7,8.6,77.1l5.2-1.1c26.8-0.5,67.5-8.7,78.4-9.9l2.2-2.2l-4-3.5L150.6,273.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.6,210.8c0.2,0.5,0.3,1,0.4,1.5c0.2,1,0.4,2.4,0.7,4.1c0.6,4.5,0.9,9.1,0.7,13.7c-0.1,2.5-0.4,5.1-1,7.5 c-0.4,2.1-1.5,4-3,5.4c-1.1,0.9-2.5,1.5-3.9,1.5c-0.4,0-0.8-0.1-1.1-0.2c-0.2-0.1-0.4-0.1-0.4-0.2c0.5,0.1,1,0.2,1.5,0.2 c1.4-0.1,2.7-0.6,3.7-1.5c1.4-1.4,2.4-3.3,2.7-5.3c0.5-2.4,0.8-4.9,0.9-7.4c0.1-4.6,0-9.1-0.6-13.7c-0.2-1.7-0.4-3.1-0.5-4.1 C86.6,211.8,86.6,211.3,86.6,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.9,225.7c-0.2-1-0.3-2.1-0.3-3.1c-0.5-5-1.6-9.9-3.5-14.5c-0.4-0.9-0.8-1.9-1.1-2.9 c0.2,0.2,0.3,0.5,0.4,0.7c0.3,0.5,0.6,1.2,1,2c1,2.3,1.8,4.7,2.4,7.2c0.6,2.4,1,4.9,1.1,7.5c0,1,0.1,1.8,0,2.3 C97,225.2,97,225.5,96.9,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.7,306.9c-0.2,0.1-0.3,0.2-0.5,0.3l-1.5,0.7c-0.6,0.3-1.4,0.7-2.4,1.1s-2,0.9-3.2,1.3 c-2.4,0.9-5.2,1.9-8.5,2.8c-3.5,0.9-7.1,1.7-10.7,2.3c-3.6,0.5-7.2,0.9-10.9,1c-3.4,0.1-6.4,0-8.9-0.2c-1.3-0.1-2.4-0.2-3.4-0.3 s-1.9-0.2-2.6-0.3l-1.6-0.3c-0.2,0-0.4-0.1-0.6-0.1c0.2,0,0.4,0,0.6,0l1.6,0.2c0.7,0.1,1.6,0.2,2.6,0.2s2.1,0.2,3.4,0.2 c2.5,0.1,5.5,0.2,8.9,0.1c7.3-0.3,14.5-1.4,21.5-3.3c3.2-0.9,6.1-1.8,8.5-2.7c1.2-0.4,2.2-0.9,3.2-1.2s1.7-0.7,2.4-1l1.5-0.6 C153.3,307,153.5,306.9,153.7,306.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2,206c2.8,6.8,5,14.9,5.2,22.2c0.2,1.5-0.1,3.1-0.7,4.5c-0.2,0.3-0.4,0.6-0.7,0.6c-0.6,0-0.7-0.8-0.7-1.3 C96.5,223.2,95.5,214.5,93.2,206"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,265.9c8.9,5.1,19,7.8,29.3,7.9c1.1-0.1,2.3,0.1,3.3,0.7c0.9,0.7,1.2,2.3,0.2,2.9c-0.3,0.1-0.7,0.2-1,0.2 c-12,1.1-23.8-3.1-32.5-11.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148.8,266.7c-0.1,0,0.5-10.4,1.5-23.3s1.9-23.3,2-23.3s-0.5,10.5-1.5,23.3S149,266.7,148.8,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.4,198.5c0.1,0.5,0.2,1,0.3,1.5c0.2,1.3,0.3,2.7,0.2,4c-0.2,9.1-4.6,17.5-12,22.8c-1.1,0.8-2.2,1.5-3.4,2.1 c-0.4,0.2-0.9,0.4-1.3,0.6c0.4-0.3,0.8-0.5,1.2-0.8c1.1-0.7,2.3-1.4,3.3-2.2c7.1-5.4,11.4-13.6,11.8-22.5c0.1-1.3,0.1-2.7,0-4 C74.4,199.4,74.4,198.9,74.4,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.7,202.7c0,0,0.1,0.1,0.3,0.4c0.2,0.4,0.5,0.8,0.7,1.1c0.7,1.5,1.2,3,1.4,4.7c0.7,4.1,0.4,9.8-0.7,16 c-0.5,2.9-1.5,5.7-2.7,8.4c-1.1,2.2-2.4,4.2-4.1,6c-1.1,1.2-2.4,2.2-3.8,3.1c-0.5,0.3-0.9,0.5-1.2,0.6c-0.1,0.1-0.3,0.1-0.4,0.2 c0,0,0.5-0.3,1.5-1c1.3-0.9,2.5-2,3.6-3.2c1.6-1.8,2.9-3.8,3.9-5.9c1.2-2.7,2.1-5.4,2.6-8.3c1.1-6.1,1.5-11.8,0.9-15.8 C83.3,206.8,82.7,204.7,81.7,202.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.4,214.9c-1.3-0.1-2.7-0.1-4,0.1c-1.3,0.3-2.5,0.8-3.7,1.5c0,0,0.2-0.4,0.9-0.9c1.6-1.1,3.7-1.5,5.6-1.1 C95,214.6,95.4,214.8,95.4,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.7,210.7c0.5,0.5,0.9,1.1,1.3,1.6c1.2,1.5,2.4,2.9,3.7,4.3c2,2,4.2,3.7,6.7,5c3,1.6,6.5,2.3,9.9,2 c3.4-0.3,6.7-1.7,9.3-3.9c2.1-1.8,3.8-4.1,4.9-6.7c0.7-1.8,1.2-3.6,1.3-5.5c0.1-1.3,0-2.1,0.1-2.1c0,0.2,0.1,0.4,0.1,0.5 c0.1,0.5,0.1,1,0.1,1.6c-0.1,1.9-0.5,3.8-1.2,5.6c-1,2.7-2.7,5.1-4.9,6.9c-5.5,4.7-13.4,5.5-19.8,2c-2.5-1.4-4.8-3.1-6.7-5.2 c-1.3-1.4-2.5-2.9-3.6-4.4c-0.4-0.5-0.7-1-0.9-1.3C95.8,211,95.7,210.9,95.7,210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,234.2c-1.8-0.3-3.6-0.4-5.3-0.2c-1.8,0.3-3.5,0.9-5.1,1.8c0.3-0.4,0.8-0.8,1.3-1 c1.1-0.7,2.4-1.1,3.7-1.3c1.3-0.2,2.6-0.1,3.9,0.1C97.3,233.7,97.8,233.9,98.2,234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.7,225.3c0,0.1-0.8-0.1-2.1,0c-1.9,0.2-3.7,0.7-5.4,1.6c-2.5,1.4-4.9,2.9-7.1,4.6c-1.4,1-2.8,1.8-4.4,2.6 c-1.6,0.8-3.4,1.4-5.1,1.8c-3.4,0.8-7,1-10.5,0.8c-2.8-0.2-5.7-0.6-8.5-1.2c-2.4-0.5-4.3-1-5.6-1.3l-1.5-0.4 c-0.2,0-0.4-0.1-0.5-0.2c0.2,0,0.4,0,0.6,0.1l1.5,0.3c1.3,0.3,3.2,0.7,5.6,1.2c2.8,0.6,5.6,0.9,8.4,1.1c3.5,0.2,6.9,0,10.3-0.8 c1.7-0.4,3.4-1,5-1.7c1.5-0.7,2.9-1.6,4.3-2.5c2.3-1.7,4.7-3.2,7.2-4.5c1.7-0.9,3.6-1.4,5.6-1.5c0.5,0,1,0,1.6,0.1 C149.3,225.2,149.5,225.2,149.7,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.6,218.6c-0.1,0-0.2-1.2-0.6-3c-1.1-4.8-3.6-9.1-7.3-12.3c-1.4-1.2-2.4-1.9-2.4-1.9 c0.3,0.1,0.5,0.2,0.7,0.4c0.7,0.4,1.3,0.8,1.9,1.3c3.9,3.2,6.6,7.7,7.5,12.6c0.1,0.7,0.2,1.5,0.2,2.2 C153.7,218,153.7,218.3,153.6,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.6,227.2c0-0.4,0-0.9,0-1.3c0-0.8,0-2-0.1-3.5c-0.2-3.9-0.8-7.7-2-11.5c-0.7-2-1.5-4-2.5-5.9 c-0.8-1.5-1.7-3-2.7-4.5c-1.7-2.4-3-3.8-2.9-3.9c0.3,0.3,0.7,0.6,0.9,0.9c0.8,0.9,1.6,1.8,2.3,2.7c1.1,1.4,2,2.9,2.9,4.5 c1,1.9,1.9,3.9,2.6,6c1.2,3.8,1.9,7.7,1.9,11.6c0,1.2,0,2.4-0.1,3.6C164.8,226.3,164.7,226.8,164.6,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.5,250.1c-0.2,0.1-0.4,0.2-0.7,0.4c-0.7,0.3-1.3,0.6-2,0.8c-2.5,0.8-5.1,1.3-7.7,1.4 c-3.9,0.1-7.8,0-11.7-0.3c-2.2-0.1-4.5-0.2-6.8-0.1c-2.4,0.1-4.9,0.5-7.3,1c-4.9,1.1-9.6,2.5-14,3c-3.9,0.4-7.8,0.3-11.7-0.2 c-3.3-0.4-5.9-0.9-7.8-1.3l-2.1-0.4c-0.2,0-0.5-0.1-0.7-0.2c0.2,0,0.5,0,0.7,0.1l2.1,0.3c1.8,0.3,4.5,0.7,7.8,1.1 c3.8,0.5,7.7,0.5,11.6,0.1c4.3-0.5,9-1.9,13.9-3c2.4-0.5,4.9-0.9,7.4-1c2.3-0.1,4.6,0,6.9,0.1c3.9,0.3,7.7,0.5,11.6,0.4 c2.6-0.1,5.2-0.5,7.7-1.2c0.9-0.3,1.6-0.5,2-0.7C148,250.3,148.2,250.2,148.5,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.6,273.1c-0.6,0-1.1,0-1.7,0c-1.1,0-2.7,0-4.6,0c-10.2,0.1-20.3,1.6-30,4.4c-1.9,0.5-3.4,1-4.4,1.4 c-0.5,0.2-1.1,0.4-1.6,0.5c0.5-0.3,1-0.5,1.6-0.7c1-0.4,2.5-0.9,4.4-1.5c9.7-3.1,19.9-4.6,30.1-4.4c1.9,0,3.5,0.1,4.6,0.2 C118.5,272.9,119,273,119.6,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.6,270.6c-0.7,0.4-1.4,0.8-2.1,1.1c-1.7,0.8-3.5,1.4-5.4,1.9c-1.8,0.5-3.7,0.9-5.6,1.2 c-0.8,0.1-1.6,0.2-2.4,0.2c0.7-0.2,1.5-0.4,2.3-0.5c1.4-0.3,3.4-0.7,5.5-1.3s4-1.2,5.4-1.8C147,271,147.8,270.7,148.6,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.7,288.3c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.2-1.2,0.5-2.1,0.9c-2.6,1.1-5.2,2-7.9,2.8 c-8.9,2.4-18,4.1-27.2,4.8c-9.2,0.8-18.4,0.9-27.7,0.2c-3.5-0.3-6.4-0.6-8.3-0.9l-2.2-0.3c-0.3,0-0.5-0.1-0.8-0.1 c0.3,0,0.5,0,0.8,0l2.3,0.2c2,0.2,4.8,0.5,8.3,0.7c9.2,0.6,18.4,0.4,27.6-0.4c9.2-0.8,18.3-2.3,27.2-4.7c3.4-0.9,6.1-1.9,8-2.6 l2.1-0.8C157.2,288.5,157.5,288.4,157.7,288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.9,314.7c-2.4-0.2-4.7-0.2-7.1,0c-2.4,0.3-4.7,0.8-7,1.5c0.6-0.4,1.2-0.7,1.9-0.9c3.2-1.1,6.7-1.5,10.1-1 C94.5,314.3,95.2,314.5,95.9,314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161,305.4c0,0.1-1.8,0.1-4,0.5s-3.9,1-3.9,0.9C155.5,305.5,158.3,305,161,305.4L161,305.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500InternalServerError);
export default __webpack_public_path__ + "static/media/500-internal-server-error.494e02d5eb05e143d0d5e4112071d13e.svg";
export { ForwardRef as ReactComponent };